/* eslint-disable react-hooks/exhaustive-deps */
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Drawer, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputLabel, Menu, OutlinedInput, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import PaidIcon from '@mui/icons-material/Paid';
import TagIcon from '@mui/icons-material/Tag';
import SellIcon from '@mui/icons-material/Sell';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import DataTable from "../../../common/DataTable";
import { useEffect, useState } from "react";
import CreateModule from "./CreateModule";
import { appendIfNotNull, BasicAccess, countries, CurrencyJSON, getProjectSize } from "../../../common/const";
import { Add, Cached, CopyAll, Edit, Save } from "@mui/icons-material";
import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined';
import { LoadingPage } from "../../../common/LoadingPage";
import { UpdateRoomDef } from "./columnDefs";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { apiRequest } from "../../../common/common";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import CreateItemFromCatalog from "./Items/CreateItemFromCatalog";
import CreateItemFromTemplate from "./Items/CreateItemFromTemplate";
import Diversity2Icon from '@mui/icons-material/Diversity2';
import EditIcon from '@mui/icons-material/Edit';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import CopyMoveDepartment from "./CopyAndMove/Department/CopyMoveDepartment";
import CopyMoveRoom from "./CopyAndMove/Room/CopyMoveRoom";
import CopyMoveItem from "./CopyAndMove/Item/CopyMoveItem";
import UpdateItem from "./Items/UpdateItem";
import { useSelector } from "react-redux";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import moment from "moment";
import PoItems from "./PoItems";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));

const Cell = styled(TableCell)({
    padding: '5px',
});

const CommonModule = ({
    label,
    innerLabel,
    columnDefs,
    onGridReady,
    rowsPerPage,
    setRowPerPage,
    searchingText,
    setSearchText,
    toolPanel,
    projectId,
    gridApi,
    onSelectionChanged,
    building,
    level,
    department,
    room,
    projectData,
    selectionType,
    selectedData,
    countData,
    groupBy,
    setGroupBy,
    productId,
    setProductId,
    manufacturerId,
    setManufacturerId,
    vendorId,
    setVendorId,
    setSelectedData,
    setColumns,
    onExport
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [open, setOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(null);
    const [updateOpen, setUpdateOpen] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [dataArr, setDataArr] = useState([]);
    const [cataLogOpen, setCatalogOpen] = useState(false);
    const [templateOpen, setTemplateOpen] = useState(false);
    const [departmentOpen, setDepartmentOpen] = useState(false);
    const [isMove, setIsMove] = useState(false);
    const [itemOpen, setItemOpen] = useState(false);
    const [actionType, setActionType] = useState(null);
    const [subActionType, setSubActionType] = useState(null);
    const [purchaseOpen, setPurchaseOpen] = useState(false);
    const [groupOpen, setGroupOpen] = useState(null);
    const [actionData, setActionData] = useState([]);
    const [actionId, setActionId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [bidGroupData, setBidGroupData] = useState([]);
    const [bidLoading, setBidLoading] = useState(false);

    const [paData, setPAData] = useState({
        name: null,
        actionno: null,
        actionid: null,
        procontactid: null,
        vendorid: null,
        vendoraddressid: null,
        vendorcontactid: null,
        actionnotes: null,
        notestosupplier: null,
        billaddressid: null,
        billcontactid: null,
        billnotes: null,
        paymentterms: null,
        shippingaddressid: null,
        shippingcontactid: null,
        shippingnotes: null,
        shippingterms: null,
        earlydelivery: null,
        laterdelivery: null,
        createddate: null,
        issueddate: null,
        quote: null,
        quote_received_date: null,
        quote_expiration_date: null,
        markcompleted: false,
        bid_group_id: null
    });
    const [resources, setResource] = useState(null);
    const [rows, setRows] = useState([
        { extension: '--', type: 'Document 1', resource: '--', size: '--' },
        { extension: '--', type: 'Document 2', resource: '--', size: '--' },
        { extension: '--', type: 'Document 3', resource: '--', size: '--' },
        { extension: '--', type: 'Document 4', resource: '--', size: '--' },
        { extension: '--', type: 'Document 5', resource: '--', size: '--' },
    ]);
    const [contactData, setContactData] = useState({
        contactid: null,
        name: null,
        email: null,
        phone: null
    });
    const [addressData, setAddressData] = useState({
        addressid: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        zipcode: null,
        name: null,
    });
    const [errors, setErrors] = useState({});
    const [contactType, setContactType] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [addressOpen, setAddressOpen] = useState(false);
    const [addressType, setAddressType] = useState(null);
    const [projectContactData, setProjectContactData] = useState([]);
    const [venderAddressData, setVenderAddressData] = useState([]);
    const [vendorContactData, setVendorContactData] = useState([]);
    const [billContactData, setBillContactData] = useState([]);
    const [billToAddressData, setBillToAddressData] = useState([]);
    const [paymentTermsData, setPaymentTermsData] = useState([]);
    const [isPaymentTerms, setIsPaymentTerms] = useState(false);
    const [paymentTerms, setPaymentTerms] = useState(null);
    const [shippingTermsData, setShippingTermsData] = useState([]);
    const [isShippingTerms, setIsShippingTerms] = useState(false);
    const [shippingTerms, setShippingTerms] = useState(null);
    const [vendorLoading, setVendorLoading] = useState(false);
    const [vendorData, setVendorData] = useState([]);
    const [vendorPage, setVendorPage] = useState(1);
    const [isVendorAvailable, setIsVendorAvailable] = useState(true);
    const [vender, setVendor] = useState({
        product_provider_id: null,
        name: null,
        email: null,
        phone: null
    });
    const [openVendor, setOpenVendor] = useState(false);
    const [groupedItems, setGroupedItems] = useState(null);

    const getVendorData = async (pageNo, searchText) => {
        try {
            setVendorLoading(true);
            const response = await apiRequest('get', `/product-provider?type=vender&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsVendorAvailable(true);
                const array = [...vendorData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setVendorData(uniqueArray);
                setVendorLoading(false);
            } else {
                setIsVendorAvailable(false);
                setVendorLoading(false);
            }
        } catch (error) {
            setVendorLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getBidGroup = async () => {
        try {
            setBidLoading(true);
            const response = await apiRequest('get', `/bid-group?organizationId=${user?.organization?.organization_id}`);
            const { data } = response.data;
            setBidGroupData(data);
            setBidLoading(false);
        } catch (error) {
            setBidLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const loadNextVendor = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = vendorPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isVendorAvailable) {
            setVendorPage(numberOfPages);
            await getVendorData(numberOfPages);
        }
    };

    const onPaginationChanged = (event) => {
        if (event.api) {
            const newPageSize = event.api.paginationGetPageSize();
            if (innerLabel === 'Building') {
                localStorage.setItem('buildingPageSize', newPageSize);
            } else if (innerLabel === 'Level') {
                localStorage.setItem('levelPageSize', newPageSize);
            } else if (innerLabel === 'Department') {
                localStorage.setItem('departmentPageSize', newPageSize);
            } else if (innerLabel === 'Room') {
                localStorage.setItem('roomPageSize', newPageSize);
            } else {
                localStorage.setItem('itemPageSize', newPageSize);
            }
            setRowPerPage(newPageSize);
        }
    };

    const fetchProjectContactData = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/contact?organizationId=${user?.organization?.organization_id}&type=project`);
            const { data } = response?.data;
            setProjectContactData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const fetchVendorContactData = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/contact?venderId=${paData.vendorid}&type=vender`);
            const { data } = response?.data;
            setVendorContactData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const fetchVendeAddressData = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/address?productProviderId=${paData.vendorid}&type=vender`);
            const { data } = response?.data;
            setVenderAddressData(data);
            setDataLoading(false);
            if (data.length === 0 && paData?.venderData?.address_line_1) {
                const data = {
                    address_line_1: paData.venderData.address_line_1,
                    address_line_2: paData.venderData.address_line_2,
                    city: paData.venderData.city,
                    state: paData.venderData.state,
                    country: paData.venderData.country,
                    pincode: paData.venderData.pincode,
                    type: 'vender',
                    organization_id: user?.organization?.organization_id,
                    project_id: projectData?.project_id,
                    product_provider_id: paData.vendorid,
                    user_id: user?.user_id
                }
                const response = await apiRequest('post', '/address', data);
                setVenderAddressData([response.data.data]);
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const fetchBillAddressData = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/address?organizationId=${user?.organization?.organization_id}&type=bill`);
            const { data } = response?.data;
            setBillToAddressData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const fetchBillContactData = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/contact?organizationId=${user?.organization?.organization_id}&type=bill`);
            const { data } = response?.data;
            setBillContactData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const fetchPaymentTerms = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/org-teams?organizationId=${user?.organization?.organization_id}&type=payment`);
            const { data } = response?.data;
            setPaymentTermsData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const fetchShippingTerms = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/org-teams?organizationId=${user?.organization?.organization_id}&type=shipping`);
            const { data } = response?.data;
            setShippingTermsData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    useEffect(() => {
        if (subActionType === 2) {
            fetchProjectContactData();
            fetchBillContactData();
            fetchBillAddressData();
            fetchPaymentTerms();
            fetchShippingTerms();
            getVendorData(vendorPage);
            if (actionType === 2 || actionType === 3) {
                getBidGroup();
            }
        }
    }, [subActionType]);

    useEffect(() => {
        if (paData.vendorid !== null) {
            fetchVendorContactData();
            fetchVendeAddressData();
        }
    }, [paData.vendorid]);

    useEffect(() => {
        const fetchData = async () => {
            if ((actionType !== 2 && actionType !== 3) && actionType !== null) {
                const venderId = selectedData.filter((a) => a.product_data?.vendor_id)?.[0]?.product_data?.vendor_id || selectedData.filter((a) => a.product?.vendor_id)?.[0]?.product?.vendor_id || null;
                if (venderId !== null) {
                    const response = await apiRequest('get', `/product-provider/${venderId}`);
                    const { data } = response.data;
                    setPAData((prevData) => ({
                        ...prevData,
                        vendorid: venderId,
                        venderData: data
                    }))
                }
            }
        }
        if (actionType !== null) {
            const updatedDocuments = rows.map(doc =>
                doc.type === 'Document 5'
                    ? {
                        ...doc, type: `Approved ${actionType === 1 ? 'Requisition' :
                            actionType === 2 ? 'Bidding' :
                                actionType === 3 ? 'Request for Quote' :
                                    actionType === 4 ? 'Purchase Order' : ''
                            }`
                    }
                    : doc
            );

            setRows(updatedDocuments);
        }

        if (selectedData) {
            setGroupedItems(Object.values(
                selectedData?.reduce((acc, item) => {
                    const productId = item.product_id;

                    if (!acc[productId]) {
                        acc[productId] = {
                            product_id: productId,
                            items: [],
                            totalQty: 0,
                            totalCost: 0
                        };
                    }

                    const subTotal = item.quantity * item.unit_price;
                    const tax = (item.quantity * item.unit_price * Number((!projectData?.is_tax_exempt ? item.tax : 0))) / 100;

                    let additionalTax = 0;
                    const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;

                    if (taxableOption?.length > 0) {
                        if (taxableOption.includes('Freight')) {
                            additionalTax += ((Number(item.freight) * projectData?.tax_rate) / 100);
                        }
                        if (taxableOption.includes('Installation')) {
                            additionalTax += ((Number(item.installation) * projectData?.tax_rate) / 100);
                        }
                        if (taxableOption.includes('Storage')) {
                            additionalTax += ((Number(item.storage) * projectData?.tax_rate) / 100);
                        }
                        if (taxableOption.includes('Fees')) {
                            additionalTax += ((Number(item.fees) * projectData?.tax_rate) / 100);
                        }
                    }

                    const itemTotalCost = subTotal + tax + Number(item.freight) + Number(item.installation) +
                        Number(item.fees) + Number(item.storage) - Number(item.discounts) -
                        Number(item.tradein) + Number(additionalTax);

                    acc[productId].items.push(item);
                    acc[productId].totalQty += item.quantity * item.room.quantity;
                    acc[productId].totalCost += itemTotalCost * item.room.quantity;

                    return acc;
                }, {})
            ).map((group) => {
                const firstItem = group.items[0];
                const product = firstItem.product;
                const numericId = product.is_customer_product
                    ? `C-${product.alternate_id}`
                    : product.numaric_sku
                        ? `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(product.numaric_sku).padStart(3, '0')}`
                        : `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(0).padStart(3, '0')}`;

                return {
                    numericId: numericId,
                    description: `${product.category.name} - ${product.sub_category.name}`,
                    model: product.model,
                    manufacturer: product?.manufacturer?.name,
                    totalQty: group.totalQty,
                    totalCost: group.totalCost,
                    product_id: group.product_id,
                    items: group.items
                };
            })
            );
        }
        fetchData();
    }, [actionType]);


    const handleFileUpload = (event, fileType) => {
        const file = event.target.files[0];
        if (file) {
            setResource((prevData) => ({
                ...prevData,
                [fileType.toLowerCase().replace(/\s+/g, '')]: file,
            }));
            setRows((prevData) =>
                prevData.map((row) => {
                    if (row.type === fileType) {
                        return {
                            ...row,
                            resource: file.name,
                            size: `${(file.size / 1024).toFixed(2)} KB`,
                            extension: file.name.split('.').pop(),
                        };
                    }
                    return row;
                })
            );
        }
    };

    const handleRemove = (fileType) => {
        setResource((prevData) => ({
            ...prevData,
            [fileType.toLowerCase().replace(/\s+/g, '')]: null,
        }));

        setRows((prevData) =>
            prevData.map((row) => {
                if (row.type === fileType) {
                    return {
                        ...row,
                        resource: '--',
                        size: '--',
                        extension: '--',
                    };
                }
                return row;
            })
        );
    }

    return (
        <Box mt={1} ml={1}>
            {open && (
                <CreateModule
                    open={open}
                    setOpen={setOpen}
                    projectData={projectData}
                    getData={() => onGridReady({
                        api: gridApi
                    })}
                    innerLabel={innerLabel}
                    projectId={projectId}
                    building={building}
                    level={level}
                    department={department}
                />
            )}
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} mb={1}>
                {selectedData?.length > 0 ? (
                    <>
                        <Typography>Selected Item: {selectedData?.length}</Typography>
                        {!selectedData?.[0]?.is_deleted && (
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box>
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setDepartmentOpen(true);
                                            setIsMove(false);
                                        }}
                                    >
                                        <CopyAll />
                                        <Typography color="primary" style={{ fontWeight: 600 }}>Copy</Typography>
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setDepartmentOpen(true);
                                            setIsMove(true);
                                        }}
                                    >
                                        <MoveUpOutlinedIcon />
                                        <Typography color="primary" style={{ fontWeight: 600, marginLeft: 2 }}>Move</Typography>
                                    </IconButton>
                                </Box>
                                {(innerLabel === 'Item') && (
                                    <Box>
                                        <IconButton
                                            size="small"
                                            onClick={() => setItemOpen(true)}
                                        >
                                            <EditIcon />
                                            <Typography color="primary" style={{ fontWeight: 600 }}>Modify</Typography>
                                        </IconButton>
                                    </Box>
                                )}
                                {(innerLabel === 'Item') && (
                                    <Box>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                if (selectedData.filter((a) => ['released', 'requisitioned', 'quote_requested', 'bidding'].includes(a.stage)).length === selectedData.length) {
                                                    setPurchaseOpen(true);
                                                } else {
                                                    showNotification('Item must be in a "Released" stage to be eligible to be added to a purchase actions', 'error');
                                                }
                                            }}
                                            disabled={!user?.organization?.Subscriptions[0]?.is_procurement_assign && !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)}
                                        >
                                            <AddShoppingCartIcon />
                                            <Typography color={!user?.organization?.Subscriptions[0]?.is_procurement_assign && !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? "" : 'primary'} style={{ fontWeight: 600 }}>Purchase Actions</Typography>
                                        </IconButton>
                                    </Box>
                                )}
                                {innerLabel === 'Room' && (
                                    <Box>
                                        <IconButton
                                            size="small"
                                            onClick={() => setUpdateOpen(true)}
                                        >
                                            <Typography color="primary" style={{ fontWeight: 600 }}>Modify</Typography>
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </>
                ) : (
                    <>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>{label}</Typography>
                        <Box>
                            {(innerLabel === 'Item' && room === null) && (
                                groupBy !== null || productId || manufacturerId || vendorId ? (
                                    <Tooltip title="Reset Grouping">
                                        <IconButton onClick={() => {
                                            setGroupBy(null);
                                            setProductId(null);
                                            setManufacturerId(null);
                                            setVendorId(null);
                                        }}>
                                            <Cached color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <>
                                        <Tooltip title="Group Item By Category / Model / Mfg / Vendor">
                                            <IconButton onClick={(e) => setGroupOpen(e.currentTarget)}>
                                                <Diversity2Icon color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <Menu
                                            id="profile-menu"
                                            open={Boolean(groupOpen)}
                                            anchorEl={groupOpen}
                                            onClose={() => setGroupOpen(null)}
                                            sx={{ marginTop: 1 }}
                                            PaperProps={{
                                                sx: {
                                                    backgroundColor: 'background.paper',
                                                    borderRadius: '8px',
                                                    boxShadow: 3,
                                                    minWidth: '200px',
                                                },
                                            }}
                                        >
                                            <div style={{ padding: '2px 10px' }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 15,
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                    onClick={() => {
                                                        setGroupOpen(null);
                                                        setGroupBy('category');
                                                    }}
                                                >
                                                    By Category
                                                </Typography>
                                            </div>
                                            <div style={{ padding: '2px 10px' }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 15,
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                    onClick={() => {
                                                        setGroupOpen(null);
                                                        setGroupBy('model');
                                                    }}
                                                >
                                                    By Model
                                                </Typography>
                                            </div>
                                            <div style={{ padding: '2px 10px' }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 15,
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                    onClick={() => {
                                                        setGroupOpen(null);
                                                        setGroupBy('manufacturer');
                                                    }}
                                                >
                                                    By Manufacturer
                                                </Typography>
                                            </div>
                                            <div style={{ padding: '2px 10px' }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 15,
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                    onClick={() => {
                                                        setGroupOpen(null);
                                                        setGroupBy('vendor');
                                                    }}
                                                >
                                                    By Vendor
                                                </Typography>
                                            </div>
                                        </Menu>
                                    </>
                                )
                            )}
                            <TextField
                                size="small"
                                id="outlined-search"
                                type="text"
                                placeholder="Search Results...."
                                style={{
                                    background: '#ebeaea',
                                }}
                                InputProps={{
                                    style: { height: 37 },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon fontSize="small" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        searchingText && ( // Show the clear icon only if there's text in the field
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        localStorage.removeItem('search');
                                                        setSearchText('');
                                                        onGridReady({
                                                            api: gridApi,
                                                            searchingText: ''
                                                        });
                                                    }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    ),
                                }}
                                value={searchingText}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onGridReady({
                                            api: gridApi,
                                            searchingText: e.target.value
                                        });
                                    }
                                }}
                            />
                            {onExport && (
                                <Tooltip title={`Export ${label} to Excel`}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<FileDownloadIcon />}
                                        onClick={onExport}
                                        style={{ marginLeft: 10, height: 35, whiteSpace: 'nowrap' }}
                                    >
                                        Export
                                    </Button>
                                </Tooltip>
                            )}
                            {isUser?.code !== 'orgGuestUser' && (
                                <Button
                                    size="small"
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    style={{
                                        marginLeft: 10,
                                        height: 35
                                    }}
                                    onClick={(e) => {
                                        if (['Room', 'Department', 'Item']?.includes(innerLabel)) {
                                            setMenuOpen(e.currentTarget);
                                        } else {
                                            setOpen(true);
                                        }
                                    }}
                                >
                                    {innerLabel === 'Item' ? 'Add Item' : 'Create'}
                                </Button>
                            )}
                            <Menu
                                id="profile-menu"
                                open={Boolean(menuOpen)}
                                anchorEl={menuOpen}
                                onClose={() => setMenuOpen(null)}
                                sx={{ marginTop: 1 }}
                                PaperProps={{
                                    sx: {
                                        backgroundColor: 'background.paper',
                                        borderRadius: '8px',
                                        boxShadow: 3,
                                        minWidth: '200px',
                                    },
                                }}
                            >
                                <div style={{ padding: '2px 10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 15,
                                            fontWeight: 'bold',
                                            textDecoration: 'none',
                                        }}
                                        onClick={() => {
                                            setMenuOpen(null);
                                            setOpen(true);
                                        }}
                                    >
                                        {innerLabel === 'Department' ? `Add Departments To Level` :
                                            innerLabel === 'Room' ? `Add Rooms To Department` :
                                                `Add Items To Room`}
                                    </Typography>
                                </div>
                                {innerLabel !== 'Item' ? (
                                    <div style={{ padding: '2px 10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: 15,
                                                textDecoration: 'none',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                setMenuOpen(null);
                                                setOpen(true);
                                            }}
                                        >
                                            Create Empty
                                        </Typography>
                                    </div>
                                ) : (
                                    <div style={{ padding: '2px 10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: 15,
                                                textDecoration: 'none',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                setMenuOpen(null);
                                                setCatalogOpen(true);
                                            }}
                                        >
                                            From Catalog
                                        </Typography>
                                    </div>
                                )}
                                <div style={{ padding: '2px 10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 15,
                                            textDecoration: 'none',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => {
                                            setMenuOpen(null);
                                            setTemplateOpen(true);
                                        }}
                                    >
                                        From Templates
                                    </Typography>
                                </div>
                            </Menu>
                        </Box>
                    </>
                )}
            </Box>
            <Box style={{ display: 'flex', padding: '6px 10px', background: 'lightgray', gap: 10 }}>
                {innerLabel === 'Item' && !groupBy && (<Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <SellIcon style={{ fontSize: 12 }} />
                    {`Total Product Quantity: ${countData?.total_product || 0} Products`}
                </Typography>)}
                {!groupBy && (
                    <>
                        <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}><TagIcon style={{ fontSize: 12 }} />{`Total ${innerLabel} Quantity: ${countData?.total_quantity || 0} ${label}`}</Typography>
                        <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}>{projectData?.currency === 'INR' ? <CurrencyRupeeIcon style={{ fontSize: 12 }} /> : <PaidIcon style={{ fontSize: 12 }} />}{`Total Cost: ${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${countData?.total_cost ? Intl.NumberFormat('en-IN').format(countData?.total_cost) : 0} `}</Typography>
                    </>
                )}
                {innerLabel !== 'Item' && (<Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <SquareFootIcon style={{ fontSize: 12 }} />
                    {`Total Area: ${getProjectSize(projectData?.default_project_units, countData?.total_area || 0)}`}
                </Typography>)}
                {groupBy && (
                    <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}>{`Total Categories: ${countData?.total_category || 0}`}</Typography>
                )}
            </Box>
            <DataTable
                height="63vh"
                columnDefs={columnDefs}
                rowsPerPage={rowsPerPage}
                paginationPageSizeSelector={[10, 15, 25, 50, 100]}
                toolPanel={toolPanel}
                onPaginationChanged={onPaginationChanged}
                singleClickEdit={false}
                modelType="infinite"
                selectionType={selectionType}
                onGridReady={onGridReady}
                fromTemplate={true}
                onSelectionChanged={onSelectionChanged}
                onColumnMoved={() => {
                    setColumns(gridApi.getAllGridColumns().map((column) => column.getColDef()));
                }}
            />
            <Drawer
                anchor="bottom"
                open={updateOpen}
                sx={{
                    '& .MuiDrawer-paper': {
                        height: '85%',
                    }
                }}
            >
                {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                <DemoBox1>
                    <Typography variant='body1' style={{ fontWeight: 'bold' }}>Update Rooms</Typography>
                    <Box>
                        <Button
                            variant='contained'
                            size="small"
                            disabled={dataArr.length === 0}
                            onClick={async () => {
                                setDataLoading(true);
                                try {
                                    const response = await apiRequest('put', '/project-room/update-multiple', {
                                        room_data: dataArr
                                    });
                                    if (response.data) {
                                        setDataLoading(false);
                                        onGridReady({
                                            api: gridApi
                                        });
                                        setUpdateOpen(false);
                                        setDataArr([]);
                                        showNotification(response?.data?.message, 'success');
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    setDataArr([]);
                                    showNotification(error?.response?.data.error || error.message, 'error');
                                }
                            }}
                        >
                            Save
                        </Button>
                        <IconButton onClick={() => {
                            setUpdateOpen(false);
                            setDataArr([]);
                        }}>
                            <ClearIcon />
                        </IconButton>
                    </Box>
                </DemoBox1>
                <Divider />
                <DataTable
                    height="75vh"
                    columnDefs={UpdateRoomDef}
                    rowData={selectedData}
                    rowsPerPage={rowsPerPage}
                    paginationPageSizeSelector={[10, 15, 25, 50, 100]}
                    onPaginationChanged={onPaginationChanged}
                    singleClickEdit={true}
                    modelType="clientSide"
                    onCellValueChanged={async (event) => {
                        const { data } = event;
                        const updatedDataArr = [...dataArr];
                        const index = updatedDataArr.findIndex((a) => a.room_id === data?.room_id);
                        if (index > -1) {
                            updatedDataArr[index] = {
                                room_name: data?.room_name,
                                room_no: data?.room_no,
                                quantity: data?.quantity,
                                room_area: data?.room_area,
                                tags: data?.tags,
                                room_signage: data?.room_signage,
                                room_id: data?.room_id
                            };
                        } else {
                            updatedDataArr.push({
                                room_name: data?.room_name,
                                room_no: data?.room_no,
                                quantity: data?.quantity,
                                room_area: data?.room_area,
                                tags: data?.tags,
                                room_signage: data?.room_signage,
                                room_id: data?.room_id
                            });
                        }
                        setDataArr(updatedDataArr);
                    }}
                />
            </Drawer>
            <Dialog open={openVendor} fullWidth maxWidth="sm">
                <DialogTitle>{vender?.product_provider_id ? 'Update Vendor' : 'Add New Vendor'}</DialogTitle>
                <DialogContent>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} md={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Name *</InputLabel>
                                <OutlinedInput
                                    label="Name *"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={vender.name || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.contactname = '';
                                        } else {
                                            newErrors.contactname = 'Please Enter Vendor Name'
                                        }
                                        setErrors(newErrors);
                                        setVendor((prevData) => ({
                                            ...prevData,
                                            name: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.contactname}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Email</InputLabel>
                                <OutlinedInput
                                    label="Email"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={vender.email || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (!/\S+@\S+\.\S+/.test(e.target.value)) {
                                            newErrors.email = 'Email is invalid';
                                        } else {
                                            newErrors.email = '';
                                        }
                                        setErrors(newErrors);
                                        setVendor((prevData) => ({
                                            ...prevData,
                                            email: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Phone</InputLabel>
                                <OutlinedInput
                                    label="Phone"
                                    id="standard-adornment-password"
                                    type='number'
                                    value={vender.phone || ''}
                                    onChange={(e) => {
                                        setVendor((prevData) => ({
                                            ...prevData,
                                            phone: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        size="Medium"
                        variant="contained"
                        onClick={async () => {
                            const newErrors = {};
                            if (vender.name === null) {
                                newErrors.contactname = 'Please Enter Vendor Name'
                            }
                            setErrors(newErrors);
                            if (Object.keys(newErrors).length === 0) {
                                setDataLoading(true);
                                try {
                                    let response;
                                    const data = {
                                        name: vender.name,
                                        email: vender.email,
                                        contactno: vender.phone,
                                        type: 'vender',
                                        status: 'active',
                                        user_id: user?.user_id,
                                        access_level: 'organization',
                                        organization_id: user?.organization?.organization_id,
                                        project_id: projectData?.project_id,
                                    }
                                    if (vender.product_provider_id !== null) {
                                        response = await apiRequest('put', `/product-provider/${vender.product_provider_id}`, data)
                                    } else {
                                        response = await apiRequest('post', '/product-provider', data)
                                    }
                                    if (response.data) {
                                        setErrors({});
                                        setOpenVendor(false);
                                        getVendorData(1);
                                        showNotification(vender.product_provider_id ? 'Vendor updated successfully' : 'Vendor created successfully', 'success');
                                        setVendor({
                                            product_provider_id: null,
                                            name: null,
                                            email: null,
                                            phone: null
                                        });
                                        setDataLoading(false);
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error')
                                }
                            }
                        }}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        size="Medium"
                        variant="contained"
                        onClick={() => {
                            setErrors({});
                            setOpenVendor(false);
                            setVendor({
                                product_provider_id: null,
                                name: null,
                                email: null,
                                phone: null
                            });
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={dialogOpen} fullWidth maxWidth="sm">
                <DialogTitle>{contactData?.contactid ? 'Update Contact' : 'Add New Contact'}</DialogTitle>
                <DialogContent>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} md={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Name *</InputLabel>
                                <OutlinedInput
                                    label="Name *"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={contactData.name || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.contactname = '';
                                        } else {
                                            newErrors.contactname = 'Please Enter Contact Name'
                                        }
                                        setErrors(newErrors);
                                        setContactData((prevData) => ({
                                            ...prevData,
                                            name: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.contactname}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Email {actionType !== 1 ? '*' : ''}</InputLabel>
                                <OutlinedInput
                                    label={`Email ${actionType !== 1 ? '*' : ''}`}
                                    id="standard-adornment-password"
                                    type='text'
                                    value={contactData.email || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value && !/\S+@\S+\.\S+/.test(e.target.value)) {
                                            newErrors.email = 'Email is invalid';
                                        } else if (actionType !== 1) {
                                            newErrors.email = 'Please Enter Email';
                                        }
                                        setErrors(newErrors);
                                        setContactData((prevData) => ({
                                            ...prevData,
                                            email: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Phone *</InputLabel>
                                <OutlinedInput
                                    label="Phone *"
                                    id="standard-adornment-password"
                                    type='number'
                                    value={contactData.phone || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.phone = '';
                                        } else {
                                            newErrors.phone = 'Please Enter Phone Number'
                                        }
                                        setErrors(newErrors);
                                        setContactData((prevData) => ({
                                            ...prevData,
                                            phone: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.phone}</Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        size="Medium"
                        variant="contained"
                        onClick={async () => {
                            const newErrors = {};
                            if (contactData.name === null) {
                                newErrors.contactname = 'Please Enter Contact Name'
                            }
                            if (contactData.phone === null) {
                                newErrors.phone = 'Please Enter Phone Number'
                            }
                            if (contactData.email === null && contactType === 'project' && actionType !== 1) {
                                newErrors.email = 'Please Enter Email'
                            }

                            setErrors(newErrors);
                            if (Object.keys(newErrors).length === 0) {
                                setDataLoading(true);
                                try {
                                    let response;
                                    const data = {
                                        name: contactData.name,
                                        email: contactData.email,
                                        phone_no: contactData.phone,
                                        type: contactType,
                                        organization_id: user?.organization?.organization_id,
                                        project_id: projectData?.project_id,
                                        vendor_id: paData.vendorid
                                    }
                                    if (contactData.contactid !== null) {
                                        response = await apiRequest('put', `/contact/${contactData?.contactid}`, data)
                                    } else {
                                        response = await apiRequest('post', '/contact', data)
                                    }
                                    if (response.data) {
                                        setErrors({});
                                        setDialogOpen(false);
                                        if (contactType === 'project') {
                                            fetchProjectContactData();
                                        } else if (contactType === 'vender') {
                                            fetchVendorContactData();
                                        } else if (contactType === 'bill') {
                                            fetchBillContactData();
                                        }
                                        setContactType(null);
                                        showNotification(contactData?.contactid ? 'Contact updated successfully' : 'Contact created successfully', 'success');
                                        setContactData({
                                            contactid: null,
                                            name: null,
                                            email: null,
                                            phone: null
                                        });
                                        setDataLoading(false);
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error')
                                }
                            }
                        }}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        size="Medium"
                        variant="contained"
                        onClick={() => {
                            setErrors({});
                            setDialogOpen(false);
                            setContactType(null);
                            setContactData({
                                contactid: null,
                                name: null,
                                email: null,
                                phone: null
                            })
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={addressOpen} fullWidth maxWidth="sm">
                <DialogTitle>{addressData.addressid ? 'Update Address' : 'Add New Address'}</DialogTitle>
                <DialogContent>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <Grid container spacing={2} mt={1}>
                        {addressType === 'bill' && (
                            <Grid item xs={12} md={6}>
                                <FormControl size="small" variant="outlined" fullWidth>
                                    <InputLabel htmlFor="standard-adornment-password">Name</InputLabel>
                                    <OutlinedInput
                                        label="Name"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={addressData.name || ''}
                                        onChange={(e) => {
                                            setAddressData((prevData) => ({
                                                ...prevData,
                                                name: e.target.value
                                            }))
                                        }}
                                    />
                                </FormControl>
                            </Grid>)}
                        <Grid item xs={12} md={6}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Address Line 1 *</InputLabel>
                                <OutlinedInput
                                    label="Address Line 1 *"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={addressData.address1 || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.address1 = '';
                                        } else {
                                            newErrors.address1 = 'Please Enter Address Line 1'
                                        }
                                        setErrors(newErrors);
                                        setAddressData((prevData) => ({
                                            ...prevData,
                                            address1: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.address1}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Address Line 2</InputLabel>
                                <OutlinedInput
                                    label="Address Line 2"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={addressData.address2 || ''}
                                    onChange={(e) => {
                                        setAddressData((prevData) => ({
                                            ...prevData,
                                            address2: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password">City *</InputLabel>
                                <OutlinedInput
                                    label="City *"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={addressData.city || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.city = '';
                                        } else {
                                            newErrors.city = 'Please Enter City'
                                        }
                                        setErrors(newErrors);
                                        setAddressData((prevData) => ({
                                            ...prevData,
                                            city: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.city}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password">State *</InputLabel>
                                <OutlinedInput
                                    label="State *"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={addressData.state || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.state = '';
                                        } else {
                                            newErrors.state = 'Please Enter State'
                                        }
                                        setErrors(newErrors);
                                        setAddressData((prevData) => ({
                                            ...prevData,
                                            state: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.state}</Typography>
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <Autocomplete
                                value={countries.find((c) => c.code === addressData.country?.toUpperCase()) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={countries}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    const newErrors = errors;
                                    if (newValue?.code) {
                                        newErrors.country = '';
                                    } else {
                                        newErrors.country = 'Please Select Country'
                                    }
                                    setErrors(newErrors);
                                    setAddressData((prevData) => ({
                                        ...prevData,
                                        country: newValue?.code
                                    }))
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Country *" name="Country *" variant="outlined" />}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.country}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password">Zip Code *</InputLabel>
                                <OutlinedInput
                                    label="Zip Code *"
                                    id="standard-adornment-password"
                                    type='number'
                                    value={addressData.zipcode || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.zipcode = '';
                                        } else {
                                            newErrors.zipcode = 'Please Enter Zip Code'
                                        }
                                        setErrors(newErrors);
                                        setAddressData((prevData) => ({
                                            ...prevData,
                                            zipcode: e.target.value
                                        }))
                                    }}
                                />
                            </FormControl>
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.zipcode}</Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        size="Medium"
                        variant="contained"
                        onClick={async () => {
                            const newErrors = {};
                            if (addressData.address1 === null) {
                                newErrors.address1 = 'Please Enter Address Line 1'
                            }
                            if (addressData.city === null) {
                                newErrors.city = 'Please Enter City'
                            }
                            if (addressData.state === null) {
                                newErrors.state = 'Please Enter State'
                            }
                            if (addressData.country === null) {
                                newErrors.country = 'Please Select Country'
                            }
                            if (addressData.zipcode === null) {
                                newErrors.zipcode = 'Please Enter Zip Code'
                            }
                            setErrors(newErrors);
                            if (Object.keys(newErrors).length === 0) {
                                setDataLoading(true);
                                try {
                                    let response;
                                    const data = {
                                        address_line_1: addressData.address1,
                                        address_line_2: addressData.address2,
                                        city: addressData.city,
                                        state: addressData.state,
                                        country: addressData.country,
                                        pincode: addressData.zipcode,
                                        name: addressData.name,
                                        type: addressType,
                                        organization_id: user?.organization?.organization_id,
                                        project_id: projectData?.project_id,
                                        product_provider_id: paData.vendorid,
                                        user_id: user?.user_id
                                    }
                                    if (addressData.addressid !== null) {
                                        response = await apiRequest('put', `/address/${addressData?.addressid}`, data)
                                    } else {
                                        response = await apiRequest('post', '/address', data)
                                    }
                                    if (response.data) {
                                        setErrors({});
                                        setAddressOpen(false);
                                        if (addressType === 'vender') {
                                            fetchVendeAddressData();
                                        } else if (addressType === 'bill') {
                                            fetchBillAddressData();
                                        }
                                        setAddressType(null);
                                        showNotification(addressData?.addressid ? 'Address updated successfully' : 'Address created successfully', 'success');
                                        setAddressData({
                                            addressid: null,
                                            address1: null,
                                            address2: null,
                                            city: null,
                                            state: null,
                                            country: null,
                                            zipcode: null,
                                            name: null,
                                        })
                                        setDataLoading(false);
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error')
                                }
                            }
                        }}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        size="Medium"
                        variant="contained"
                        onClick={() => {
                            setErrors({});
                            setAddressOpen(false);
                            setAddressType(null);
                            setAddressData({
                                addressid: null,
                                address1: null,
                                address2: null,
                                city: null,
                                state: null,
                                country: null,
                                zipcode: null,
                                name: null,
                            })
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={purchaseOpen} fullWidth maxWidth={actionType === null ? "sm" : "lg"}>
                {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                <DialogTitle style={{
                    background: '#1976d2',
                    color: 'white'
                }}>{subActionType !== null ? `
                     ${subActionType === 1 ? `Assign To Existing ${actionType === 1 ? 'Requisition' :
                        actionType === 2 ? 'Bidding' :
                            actionType === 3 ? 'Request for Quote' :
                                actionType === 4 ? 'Purchase Order' :
                                    'Purchase'} ` :
                        subActionType === 2 ? `New ${actionType === 1 ? 'Requisition' :
                            actionType === 2 ? 'Bidding' :
                                actionType === 3 ? 'Request for Quote' :
                                    actionType === 4 ? 'Purchase Order' :
                                        'Purchase'} ` : ''}
                    `:
                    `${actionType === 1 ? 'Requisition' :
                        actionType === 2 ? 'Bidding' :
                            actionType === 3 ? 'Request for Quote' :
                                actionType === 4 ? 'Purchase Order' :
                                    'Purchase'} 
                        Actions`
                    }</DialogTitle>
                <Divider />
                <DialogContent>
                    {actionType !== null ?
                        subActionType === 1 ? (
                            <center>
                                <Box>
                                    <Typography>Project: {projectData?.name}</Typography>
                                    <Typography>Vendor: {selectedData.filter((a) => a.product_data?.vendor?.name)?.[0]?.product_data?.vendor?.name || selectedData.filter((a) => a.product?.vendor?.name)?.[0]?.product?.vendor?.name || '--'}</Typography>
                                    <Typography>Number of Items: {selectedData?.length}</Typography>
                                </Box>
                                <PoItems
                                    groupedItems={groupedItems}
                                    projectData={projectData}
                                    actionName={actionType === 1 ? 'requisition' : actionType === 2 ? 'bidding' : actionType === 3 ? 'rfq' : actionType === 4 ? 'purchase_action' : ''}
                                    isFromCreate
                                />
                                <br />
                                <Box sx={{ width: '70%' }}>
                                    <Autocomplete
                                        value={actionData.find((c) => c.purchase_module_id === actionId) || null}
                                        id="combo-box-demo"
                                        size="small"
                                        fullWidth
                                        options={actionData}
                                        getOptionLabel={(option) => `${option?.action_name}-${option.action_id}-${option.action_no}`}
                                        onChange={async (event, newValue) => {
                                            setActionId(newValue?.purchase_module_id || null);
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                fullWidth
                                                {...params}
                                                label={`Select ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bidding' : actionType === 3 ? 'Request For Quote' : "Purchase Order"}`}
                                                name={`Select ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bidding' : actionType === 3 ? 'Request For Quote' : "Purchase Order"}`}
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />}
                                    />
                                </Box>
                            </center>
                        ) : subActionType === 2 ? (
                            <Box>
                                <Accordion style={{ width: '100%' }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Typography style={{ fontWeight: 'bold' }}>Items</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <PoItems
                                            groupedItems={groupedItems}
                                            projectData={projectData}
                                            actionName={actionType === 1 ? 'requisition' : actionType === 2 ? 'bidding' : actionType === 3 ? 'rfq' : actionType === 4 ? 'purchase_action' : ''}
                                            isFromCreate
                                        />
                                    </AccordionDetails>
                                </Accordion>
                                <Typography style={{ fontWeight: 800, margin: '10px 15px' }}>Details</Typography>
                                <Grid container spacing={2} mb={1}>
                                    <Grid item xs={12} md={3}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">{actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} Name *</InputLabel>
                                            <OutlinedInput
                                                label={`${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} Name *`}
                                                id="standard-adornment-password"
                                                type='text'
                                                value={paData.name || ''}
                                                onChange={(e) => {
                                                    const newErrors = errors;
                                                    if (e.target.value) {
                                                        newErrors.name = '';
                                                    } else {
                                                        newErrors.name = `Please Enter ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} Name`
                                                    }
                                                    setErrors(newErrors);
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        name: e.target.value
                                                    }));
                                                }}
                                            />
                                        </FormControl>
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.name}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">{actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} ID</InputLabel>
                                            <OutlinedInput
                                                label={`${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} ID`}
                                                id="standard-adornment-password"
                                                type='text'
                                                value={paData.actionid || ''}
                                                disabled
                                            />
                                        </FormControl>
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.actionid}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">{actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} # *</InputLabel>
                                            <OutlinedInput
                                                label={`${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} # *`}
                                                id="standard-adornment-password"
                                                type='text'
                                                value={paData.actionno || ''}
                                                onChange={(e) => {
                                                    const newErrors = errors;
                                                    if (e.target.value) {
                                                        newErrors.actionno = '';
                                                    } else {
                                                        newErrors.actionno = `Please Enter ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} No`
                                                    }
                                                    setErrors(newErrors);
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        actionno: e.target.value
                                                    }));
                                                }}
                                            />
                                        </FormControl>
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.actionno}</Typography>
                                    </Grid>
                                    {(actionType === 2 || actionType === 3) && (
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                value={bidGroupData?.find((c) => c.bid_group_id === paData?.bid_group_id) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                clearIcon={null}
                                                options={bidGroupData}
                                                getOptionLabel={(option) => option?.name}
                                                onChange={(event, newValue) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        bid_group_id: newValue?.bid_group_id || null,
                                                    }));
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth {...params}
                                                        label="Bid Group"
                                                        name="Bid Group"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {bidLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} md={3}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Autocomplete
                                                value={projectContactData.find((c) => c.contact_id === paData?.procontactid) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                options={projectContactData}
                                                getOptionLabel={(option) => option?.name}
                                                onChange={async (event, newValue) => {
                                                    const newErrors = errors;
                                                    if (newValue?.contact_id) {
                                                        newErrors.projectcontact = '';
                                                    } else if (actionType !== 1) {
                                                        newErrors.projectcontact = 'Please select project contact'
                                                    }
                                                    setErrors(newErrors);
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        procontactid: newValue?.contact_id || null,
                                                    }));
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        {...params}
                                                        label={`Project Contact ${actionType !== 1 ? '*' : ''}`}
                                                        name={`Project Contact ${actionType !== 1 ? '*' : ''}`}
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                            {paData.procontactid !== null && (
                                                <Tooltip
                                                    title="Edit Project Contact">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (paData.procontactid !== null) {
                                                                const response = await apiRequest('get', `/contact/${paData.procontactid}`);
                                                                const { data } = response.data;
                                                                setContactData((prevData) => ({
                                                                    ...prevData,
                                                                    contactid: data.contact_id,
                                                                    name: data.name,
                                                                    email: data.email,
                                                                    phone: data?.phone_no
                                                                }));
                                                            }
                                                            setDialogOpen(true);
                                                            setContactType('project');
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            <Tooltip
                                                title="Add Project Contact">
                                                <IconButton
                                                    onClick={async () => {
                                                        setDialogOpen(true);
                                                        setContactType('project');
                                                    }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.projectcontact}</Typography>
                                    </Grid>
                                    {(actionType !== 2 && actionType !== 3) && (
                                        <Grid item xs={12} md={6}>
                                            <Box display="flex" gap={1} mt={1}>
                                                <TextField
                                                    label="Created Date"
                                                    id="created-date"
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    value={paData?.createddate || ''}
                                                    onChange={(e) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            createddate: e.target.value || null,
                                                        }));
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: paData?.createddate !== '', // Shrink label when input is filled
                                                    }}
                                                    inputProps={{
                                                        style: { padding: '10px' }, // Adjust padding and height if needed
                                                    }}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    label="Issue Date"
                                                    id="issue-date"
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    value={paData?.issueddate || ''}
                                                    onChange={(e) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            issueddate: e.target.value || null,
                                                        }));
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: paData?.issueddate !== '', // Shrink label when input is filled
                                                    }}
                                                    inputProps={{
                                                        style: { padding: '10px' }, // Adjust padding and height if needed
                                                    }}
                                                    variant="outlined"
                                                />
                                            </Box>
                                        </Grid>)}
                                    <Grid item xs={12} md={6}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">{actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} Notes</InputLabel>
                                            <OutlinedInput
                                                label={`${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} Notes`}
                                                id="standard-adornment-password"
                                                type='text'
                                                multiline
                                                minRows={3}
                                                maxRows={5}
                                                value={paData.actionnotes || ''}
                                                onChange={(e) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        actionnotes: e.target.value
                                                    }));
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {(actionType !== 2 && actionType !== 3) && (
                                    <>
                                        <Typography style={{ fontWeight: 800, margin: '10px 15px' }}>Vendor</Typography>
                                        <Grid container spacing={2} mb={1}>
                                            <Grid item xs={12} md={3}>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Autocomplete
                                                        value={vendorData.find((c) => c.product_provider_id === paData?.vendorid) || null}
                                                        id="combo-box-demo"
                                                        size="small"
                                                        fullWidth
                                                        options={vendorData}
                                                        getOptionLabel={(option) => option?.name}
                                                        ListboxProps={{
                                                            onScroll: (event) => loadNextVendor(event),
                                                        }}
                                                        onChange={async (event, newValue) => {
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                vendorid: newValue?.product_provider_id || null,
                                                                venderData: newValue,
                                                                vendoraddressid: null,
                                                                vendorcontactid: null
                                                            }));
                                                            const newErrors = errors;
                                                            if (!newValue?.product_provider_id && actionType === 4) {
                                                                newErrors.venderAddress = '';
                                                                newErrors.vendorcontactid = '';
                                                                newErrors.vender = 'Please select vendor'
                                                            } else {
                                                                newErrors.venderAddress = '';
                                                                newErrors.vendorcontactid = '';
                                                                newErrors.vender = '';
                                                            }
                                                            setErrors(newErrors);
                                                        }}
                                                        onInputChange={(e) => {
                                                            if (e) {
                                                                if (e?.target?.value?.length >= 1) {
                                                                    setVendorData([]);
                                                                    setVendorPage(1);
                                                                    getVendorData(1, e?.target?.value);
                                                                }
                                                            }
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                fullWidth
                                                                {...params}
                                                                label="Vendor"
                                                                name="Vendor"
                                                                variant="outlined"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />}
                                                    />
                                                    {paData.vendorid !== null && (
                                                        <Tooltip
                                                            title="Edit Vendor">
                                                            <IconButton
                                                                onClick={async () => {
                                                                    if (paData.vendorid !== null) {
                                                                        const response = await apiRequest('get', `/product-provider/${paData.vendorid}`);
                                                                        const { data } = response.data;
                                                                        if (data.access_level === 'public') {
                                                                            showNotification(`You can't update catalog vendor details`, 'error');
                                                                        } else {
                                                                            setVendor({
                                                                                product_provider_id: data.product_provider_id,
                                                                                name: data.name,
                                                                                email: data.email,
                                                                                phone: data.contactno
                                                                            });
                                                                            setOpenVendor(true);
                                                                        }
                                                                    } else {
                                                                        setOpenVendor(true);
                                                                    }
                                                                }}
                                                            >
                                                                <Edit />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                    <Tooltip
                                                        title="Add Vendor">
                                                        <IconButton
                                                            onClick={async () => {
                                                                setOpenVendor(true);
                                                            }}
                                                        >
                                                            <Add />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                                <Typography variant='body2' style={{ color: 'red' }}>{errors.vender}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Autocomplete
                                                        value={venderAddressData.find((c) => c.address_id === paData?.vendoraddressid) || null}
                                                        id="combo-box-demo"
                                                        size="small"
                                                        fullWidth
                                                        options={venderAddressData}
                                                        disabled={!paData.vendorid}
                                                        getOptionLabel={(option) => `${option.address_line_1 !== null ? option.address_line_1 : ''} ${option.address_line_2 !== null ? option.address_line_2 : ''} ${option.city !== null ? option.city : ''} ${option.state !== null ? option.state : ''} ${option.country !== null ? countries.find((a) => a.code === option.country.toUpperCase())?.name : ''} ${option.pincode !== null ? option.pincode : ''}`}
                                                        onChange={async (event, newValue) => {
                                                            const newErrors = errors;
                                                            if (newValue?.address_id) {
                                                                newErrors.venderAddress = '';
                                                            } else {
                                                                newErrors.venderAddress = 'Please select vendor location'
                                                            }
                                                            setErrors(newErrors);
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                vendoraddressid: newValue?.address_id || null,
                                                            }));
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                fullWidth
                                                                {...params}
                                                                label="Location"
                                                                name="location"
                                                                variant="outlined"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />}
                                                    />
                                                    {paData.vendoraddressid !== null && (
                                                        <Tooltip
                                                            title="Edit Vendor Address">
                                                            <IconButton
                                                                disabled={!paData.vendorid}
                                                                onClick={async () => {
                                                                    if (paData.vendoraddressid !== null) {
                                                                        const response = await apiRequest('get', `/address/${paData.vendoraddressid}`);
                                                                        const { data } = response.data;
                                                                        setAddressData((prevData) => ({
                                                                            ...prevData,
                                                                            addressid: data?.address_id,
                                                                            address1: data.address_line_1,
                                                                            address2: data.address_line_2,
                                                                            city: data.city,
                                                                            state: data?.state,
                                                                            country: data.country,
                                                                            zipcode: data.pincode,
                                                                            name: data.name,
                                                                        }));
                                                                    }
                                                                    setAddressOpen(true);
                                                                    setAddressType('vender');
                                                                }}
                                                            >
                                                                <Edit />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                    <Tooltip
                                                        title="Add Vendor Address">
                                                        <IconButton
                                                            disabled={!paData.vendorid}
                                                            onClick={async () => {
                                                                setAddressOpen(true);
                                                                setAddressType('vender');
                                                            }}
                                                        >
                                                            <Add />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                                <Typography variant='body2' style={{ color: 'red' }}>{errors.venderAddress}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Autocomplete
                                                        value={vendorContactData.find((c) => c.contact_id === paData?.vendorcontactid) || null}
                                                        id="combo-box-demo"
                                                        size="small"
                                                        fullWidth
                                                        options={vendorContactData}
                                                        disabled={!paData.vendorid}
                                                        getOptionLabel={(option) => option?.name}
                                                        onChange={async (event, newValue) => {
                                                            const newErrors = errors;
                                                            if (newValue?.contact_id) {
                                                                newErrors.vendorcontactid = '';
                                                            } else {
                                                                newErrors.vendorcontactid = 'Please select vendor contact'
                                                            }
                                                            setErrors(newErrors);
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                vendorcontactid: newValue?.contact_id || null,
                                                            }));
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                fullWidth
                                                                {...params}
                                                                label="Vendor Contact"
                                                                name="Vendor Contact"
                                                                variant="outlined"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />}
                                                    />
                                                    {paData.vendorcontactid !== null && (
                                                        <Tooltip
                                                            title="Edit Vendor Contact">
                                                            <IconButton
                                                                disabled={!paData.vendorid}
                                                                onClick={async () => {
                                                                    if (paData.vendorcontactid !== null) {
                                                                        const response = await apiRequest('get', `/contact/${paData.vendorcontactid}`);
                                                                        const { data } = response.data;
                                                                        setContactData((prevData) => ({
                                                                            ...prevData,
                                                                            contactid: data.contact_id,
                                                                            name: data.name,
                                                                            email: data.email,
                                                                            phone: data?.phone_no
                                                                        }));
                                                                    }
                                                                    setDialogOpen(true);
                                                                    setContactType('vender');
                                                                }}
                                                            >
                                                                <Edit />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                    <Tooltip
                                                        title="Add Vendor Contact">
                                                        <IconButton
                                                            disabled={!paData.vendorid}
                                                            onClick={async () => {
                                                                setDialogOpen(true);
                                                                setContactType('vender');
                                                            }}
                                                        >
                                                            <Add />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                                <Typography variant='body2' style={{ color: 'red' }}>{errors.vendorcontactid}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <FormControl size="small" variant="outlined" fullWidth>
                                                    <InputLabel htmlFor="standard-adornment-password">Notes to supplier</InputLabel>
                                                    <OutlinedInput
                                                        label="Notes to supplier"
                                                        id="standard-adornment-password"
                                                        type='text'
                                                        multiline
                                                        minRows={3}
                                                        maxRows={5}
                                                        value={paData.notestosupplier || ''}
                                                        onChange={(e) => {
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                notestosupplier: e.target.value
                                                            }));
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                    </>
                                )}
                                {(actionType !== 2 && actionType !== 3) && (
                                    <>
                                        <Typography style={{ fontWeight: 800, margin: '10px 15px' }}>Quote</Typography>
                                        <Grid container spacing={2} mb={1}>
                                            <Grid item xs={12} md={3}>
                                                <FormControl size="small" variant="outlined" fullWidth>
                                                    <InputLabel htmlFor="standard-adornment-password">Quote</InputLabel>
                                                    <OutlinedInput
                                                        label="Quote"
                                                        id="standard-adornment-password"
                                                        type='text'
                                                        value={paData.quote || ''}
                                                        onChange={(e) => {
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                quote: e.target.value
                                                            }));
                                                        }}
                                                        inputProps={{
                                                            style: { padding: '10px' }, // Adjust padding and height if needed
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box display="flex" gap={1}>
                                                    <TextField
                                                        label="Quote Received Date"
                                                        id="quote-date"
                                                        type="date"
                                                        fullWidth
                                                        size="small"
                                                        value={paData?.quote_received_date || ''}
                                                        onChange={(e) => {
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                quote_received_date: e.target.value || null,
                                                            }));
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: paData?.quote_received_date !== '', // Shrink label when input is filled
                                                        }}
                                                        inputProps={{
                                                            style: { padding: '10px' }, // Adjust padding and height if needed
                                                        }}
                                                        variant="outlined"
                                                    />
                                                    <TextField
                                                        label="Quote Expire Date"
                                                        id="quote-expire-date"
                                                        type="date"
                                                        fullWidth
                                                        size="small"
                                                        value={paData?.quote_expiration_date || ''}
                                                        onChange={(e) => {
                                                            setPAData((prevData) => ({
                                                                ...prevData,
                                                                quote_expiration_date: e.target.value || null,
                                                            }));
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: paData?.quote_expiration_date !== '', // Shrink label when input is filled
                                                        }}
                                                        inputProps={{
                                                            style: { padding: '10px' }, // Adjust padding and height if needed
                                                        }}
                                                        variant="outlined"
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                    </>)}
                                <Typography style={{ fontWeight: 800, margin: '10px 15px' }}>Bill To</Typography>
                                <Grid container spacing={2} mb={1}>
                                    <Grid item xs={12} md={3}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Autocomplete
                                                value={billToAddressData.find((c) => c.address_id === paData?.billaddressid) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                options={billToAddressData}
                                                getOptionLabel={(option) => `${(option.name !== null && option.name !== 'null') ? option.name : `${option.address_line_1 !== null ? option.address_line_1 : ''} ${option.address_line_2 !== null ? option.address_line_2 : ''} ${option.city !== null ? option.city : ''} ${option.state !== null ? option.state : ''} ${option.country !== null ? countries.find((a) => a.code === option.country.toUpperCase())?.name : ''} ${option.pincode !== null ? option.pincode : ''}`}`}
                                                onChange={async (event, newValue) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        billaddressid: newValue?.address_id || null,
                                                    }));
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        {...params}
                                                        label="Bill To Address"
                                                        name="Bill To Address"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                            {paData?.billaddressid !== null && (
                                                <Tooltip
                                                    title="Edit Bill To Address">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (paData.billaddressid !== null) {
                                                                const response = await apiRequest('get', `/address/${paData.billaddressid}`);
                                                                const { data } = response.data;
                                                                setAddressData((prevData) => ({
                                                                    ...prevData,
                                                                    addressid: data?.address_id,
                                                                    address1: data.address_line_1,
                                                                    address2: data.address_line_2,
                                                                    city: data.city,
                                                                    state: data?.state,
                                                                    country: data.country,
                                                                    zipcode: data.pincode,
                                                                    name: data.name,
                                                                }));
                                                            }
                                                            setAddressOpen(true);
                                                            setAddressType('bill');
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            <Tooltip
                                                title="Add Bill To Address">
                                                <IconButton
                                                    onClick={async () => {
                                                        setAddressOpen(true);
                                                        setAddressType('bill');
                                                    }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Autocomplete
                                                value={billContactData.find((c) => c.contact_id === paData?.billcontactid) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                options={billContactData}
                                                getOptionLabel={(option) => option?.name}
                                                onChange={async (event, newValue) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        billcontactid: newValue?.contact_id || null,
                                                    }));
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        {...params}
                                                        label="Bill To Contact"
                                                        name="Bill To Contact"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                            {paData.billcontactid !== null && (
                                                <Tooltip
                                                    title="Edit Bill To Contact">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (paData.billcontactid !== null) {
                                                                const response = await apiRequest('get', `/contact/${paData.billcontactid}`);
                                                                const { data } = response.data;
                                                                setContactData((prevData) => ({
                                                                    ...prevData,
                                                                    contactid: data.contact_id,
                                                                    name: data.name,
                                                                    email: data.email,
                                                                    phone: data?.phone_no
                                                                }));
                                                            }
                                                            setDialogOpen(true);
                                                            setContactType('bill');
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            <Tooltip
                                                title="Add Bill To Contact">
                                                <IconButton
                                                    onClick={async () => {
                                                        setDialogOpen(true);
                                                        setContactType('bill');
                                                    }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        {isPaymentTerms ? (
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl size="small" variant="outlined" fullWidth>
                                                    <InputLabel htmlFor="standard-adornment-password">Payment Terms</InputLabel>
                                                    <OutlinedInput
                                                        label="Payment Terms"
                                                        id="standard-adornment-password"
                                                        type='text'
                                                        value={paymentTerms || ''}
                                                        onChange={(e) => {
                                                            setPaymentTerms(e.target.value)
                                                        }}
                                                    />
                                                </FormControl>
                                                <Tooltip
                                                    title="Save Payment Terms">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (paymentTerms !== null) {
                                                                let response;
                                                                setDataLoading(true);
                                                                const data = {
                                                                    teams: paymentTerms,
                                                                    type: 'payment',
                                                                    organization_id: user?.organization?.organization_id,
                                                                    project_id: projectData?.project_id
                                                                }
                                                                if (paData.paymentterms) {
                                                                    response = await apiRequest('put', `/org-teams/${paData.paymentterms}`, data);
                                                                } else {
                                                                    response = await apiRequest('post', `/org-teams`, data)
                                                                }
                                                                if (response.data) {
                                                                    setDataLoading(false);
                                                                    setPaymentTerms(null);
                                                                    showNotification('Payment Terms Saved Successfully', 'success');
                                                                }
                                                            }
                                                            fetchPaymentTerms();
                                                            setIsPaymentTerms(false);
                                                        }}
                                                    >
                                                        <Save />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        ) : (
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <Autocomplete
                                                    value={paymentTermsData.find((c) => c.teams_id === paData?.paymentterms) || null}
                                                    id="combo-box-demo"
                                                    size="small"
                                                    fullWidth
                                                    options={paymentTermsData}
                                                    getOptionLabel={(option) => option?.teams}
                                                    onChange={async (event, newValue) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            paymentterms: newValue?.teams_id || null,
                                                        }));
                                                    }}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            fullWidth
                                                            {...params}
                                                            label="Payment Terms"
                                                            name="Payment Terms"
                                                            variant="outlined"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />}
                                                />
                                                {paData.paymentterms !== null && (
                                                    <Tooltip
                                                        title="Edit Payment Terms">
                                                        <IconButton
                                                            onClick={async () => {
                                                                if (paData.paymentterms !== null) {
                                                                    const response = await apiRequest('get', `/org-teams/${paData.paymentterms}`);
                                                                    const { data } = response.data;
                                                                    setPaymentTerms(data?.teams)
                                                                }
                                                                setIsPaymentTerms(true);
                                                            }}
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                <Tooltip
                                                    title="Add Payment Terms">
                                                    <IconButton
                                                        onClick={async () => {
                                                            setIsPaymentTerms(true);
                                                        }}
                                                    >
                                                        <Add />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">Billing Notes</InputLabel>
                                            <OutlinedInput
                                                label="Billing Notes"
                                                id="standard-adornment-password"
                                                type='text'
                                                multiline
                                                minRows={3}
                                                maxRows={5}
                                                value={paData.billnotes || ''}
                                                onChange={(e) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        billnotes: e.target.value
                                                    }));
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <Typography style={{ fontWeight: 800, margin: '10px 15px' }}>Ship To</Typography>
                                <Grid container spacing={2} mb={1}>
                                    <Grid item xs={12} md={3}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Autocomplete
                                                value={billToAddressData.find((c) => c.address_id === paData?.shippingaddressid) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                options={billToAddressData}
                                                getOptionLabel={(option) => `${(option.name !== null && option.name !== 'null') ? option.name : `${option.address_line_1 !== null ? option.address_line_1 : ''} ${option.address_line_2 !== null ? option.address_line_2 : ''} ${option.city !== null ? option.city : ''} ${option.state !== null ? option.state : ''} ${option.country !== null ? countries.find((a) => a.code === option.country.toUpperCase())?.name : ''} ${option.pincode !== null ? option.pincode : ''}`}`}
                                                onChange={async (event, newValue) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        shippingaddressid: newValue?.address_id || null,
                                                    }));
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        {...params}
                                                        label="Ship To Address"
                                                        name="Ship To Address"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                            {paData.shippingaddressid !== null && (
                                                <Tooltip
                                                    title="Edit Ship To Address">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (paData.shippingaddressid !== null) {
                                                                const response = await apiRequest('get', `/address/${paData.shippingaddressid}`);
                                                                const { data } = response.data;
                                                                setAddressData((prevData) => ({
                                                                    ...prevData,
                                                                    addressid: data?.address_id,
                                                                    address1: data.address_line_1,
                                                                    address2: data.address_line_2,
                                                                    city: data.city,
                                                                    state: data?.state,
                                                                    country: data.country,
                                                                    zipcode: data.pincode,
                                                                    name: data.name,
                                                                }));
                                                            }
                                                            setAddressOpen(true);
                                                            setAddressType('bill');
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            <Tooltip
                                                title="Add Ship To Address">
                                                <IconButton
                                                    onClick={async () => {
                                                        setAddressOpen(true);
                                                        setAddressType('bill');
                                                    }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Autocomplete
                                                value={billContactData.find((c) => c.contact_id === paData?.shippingcontactid) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                options={billContactData}
                                                getOptionLabel={(option) => option?.name}
                                                onChange={async (event, newValue) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        shippingcontactid: newValue?.contact_id || null,
                                                    }));
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        {...params}
                                                        label="Ship To Contact"
                                                        name="Ship To Contact"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                            {paData.shippingcontactid !== null && (
                                                <Tooltip
                                                    title="Edit Ship To Contact">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (paData.shippingcontactid !== null) {
                                                                const response = await apiRequest('get', `/contact/${paData.shippingcontactid}`);
                                                                const { data } = response.data;
                                                                setContactData((prevData) => ({
                                                                    ...prevData,
                                                                    contactid: data.contact_id,
                                                                    name: data.name,
                                                                    email: data.email,
                                                                    phone: data?.phone_no
                                                                }));
                                                            }
                                                            setDialogOpen(true);
                                                            setContactType('bill');
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            <Tooltip
                                                title="Add Ship To Contact">
                                                <IconButton
                                                    onClick={async () => {
                                                        setDialogOpen(true);
                                                        setContactType('bill');
                                                    }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        {isShippingTerms ? (
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl size="small" variant="outlined" fullWidth>
                                                    <InputLabel htmlFor="standard-adornment-password">Freight Terms</InputLabel>
                                                    <OutlinedInput
                                                        label="Freight Terms"
                                                        id="standard-adornment-password"
                                                        type='text'
                                                        value={shippingTerms || ''}
                                                        onChange={(e) => {
                                                            setShippingTerms(e.target.value)
                                                        }}
                                                    />
                                                </FormControl>
                                                <Tooltip
                                                    title="Save Freight Terms">
                                                    <IconButton
                                                        onClick={async () => {
                                                            if (shippingTerms !== null) {
                                                                let response;
                                                                setDataLoading(true);
                                                                const data = {
                                                                    teams: shippingTerms,
                                                                    type: 'shipping',
                                                                    organization_id: user?.organization?.organization_id,
                                                                    project_id: projectData?.project_id
                                                                }
                                                                if (paData.shippingterms) {
                                                                    response = await apiRequest('put', `/org-teams/${paData.shippingterms}`, data);
                                                                } else {
                                                                    response = await apiRequest('post', `/org-teams`, data)
                                                                }
                                                                if (response.data) {
                                                                    setDataLoading(false);
                                                                    setShippingTerms(null);
                                                                    showNotification('Freight Terms Saved Successfully', 'success');
                                                                }
                                                            }
                                                            fetchShippingTerms();
                                                            setIsShippingTerms(false);
                                                        }}
                                                    >
                                                        <Save />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        ) : (
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <Autocomplete
                                                    value={shippingTermsData.find((c) => c.teams_id === paData?.shippingterms) || null}
                                                    id="combo-box-demo"
                                                    size="small"
                                                    fullWidth
                                                    options={shippingTermsData}
                                                    getOptionLabel={(option) => option?.teams}
                                                    onChange={async (event, newValue) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            shippingterms: newValue?.teams_id || null,
                                                        }));
                                                    }}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            fullWidth
                                                            {...params}
                                                            label="Freight Terms"
                                                            name="Freight Terms"
                                                            variant="outlined"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />}
                                                />
                                                {paData?.shippingterms !== null && (
                                                    <Tooltip
                                                        title="Edit Freight Terms">
                                                        <IconButton
                                                            onClick={async () => {
                                                                if (paData.shippingterms !== null) {
                                                                    const response = await apiRequest('get', `/org-teams/${paData.shippingterms}`);
                                                                    const { data } = response.data;
                                                                    setShippingTerms(data?.teams)
                                                                }
                                                                setIsShippingTerms(true);
                                                            }}
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                <Tooltip
                                                    title="Add Freight Terms">
                                                    <IconButton
                                                        onClick={async () => {
                                                            setIsShippingTerms(true);
                                                        }}
                                                    >
                                                        <Add />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">Shipping Notes</InputLabel>
                                            <OutlinedInput
                                                label="Shipping Notes"
                                                id="standard-adornment-password"
                                                type='text'
                                                multiline
                                                minRows={3}
                                                maxRows={5}
                                                value={paData.shippingnotes || ''}
                                                onChange={(e) => {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        shippingnotes: e.target.value
                                                    }));
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    {(actionType !== 2 && actionType !== 3) && (
                                        <Grid item xs={12} md={6}>
                                            <Typography style={{ fontSize: 14, fontWeight: 600 }}>Delivery Dates</Typography>
                                            <Box display="flex" gap={1} mt={1}>
                                                <TextField
                                                    label="No Earlier Than"
                                                    id="early-date"
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    value={paData?.earlydelivery || ''}
                                                    onChange={(e) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            earlydelivery: e.target.value || null,
                                                        }));
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: paData?.earlydelivery !== '', // Shrink label when input is filled
                                                    }}
                                                    inputProps={{
                                                        style: { padding: '10px' }, // Adjust padding and height if needed
                                                    }}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    label="No Later Than"
                                                    id="later-date"
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    value={paData?.laterdelivery || ''}
                                                    onChange={(e) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            laterdelivery: e.target.value || null,
                                                        }));
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: paData?.laterdelivery !== '', // Shrink label when input is filled
                                                    }}
                                                    inputProps={{
                                                        style: { padding: '10px' }, // Adjust padding and height if needed
                                                    }}
                                                    variant="outlined"
                                                />
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>
                                <Divider />
                                <Typography style={{ fontWeight: 800, margin: '10px 15px' }}>Resources</Typography>
                                <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                                    <TableContainer>
                                        <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                            <TableHead>
                                                <TableRow>
                                                    <Cell>Extension</Cell>
                                                    <Cell>Type</Cell>
                                                    <Cell>Resource</Cell>
                                                    <Cell>Size</Cell>
                                                    <Cell>Action</Cell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row, index) => {
                                                    return (
                                                        <TableRow key={index}>
                                                            <Cell>
                                                                <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                                                    {row.extension !== '--' && (<img src="/images/pdf.svg" alt="blog img" style={{ width: 15 }} />)}
                                                                    {row.extension}
                                                                </Box>
                                                            </Cell>
                                                            <Cell>{row.type}</Cell>
                                                            <Cell>
                                                                {row.resource}
                                                            </Cell>
                                                            <Cell>{row.size}</Cell>
                                                            <Cell>
                                                                {row.extension !== '--' ? (
                                                                    <IconButton onClick={() => handleRemove(row.type)} style={{ padding: 0 }}>
                                                                        <RemoveCircleOutlineIcon />
                                                                    </IconButton>
                                                                ) : (
                                                                    <IconButton
                                                                        component="label"
                                                                        style={{ padding: 0 }}
                                                                    >
                                                                        <CloudUploadIcon />
                                                                        <VisuallyHiddenInput
                                                                            type="file"
                                                                            onChange={(event) => {
                                                                                handleFileUpload(event, row.type)
                                                                            }}
                                                                            accept=".pdf"
                                                                        />
                                                                    </IconButton>
                                                                )}
                                                            </Cell>
                                                        </TableRow>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                                {(![2, 3, 4].includes(actionType)) && (
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={paData.markcompleted}
                                                    onClick={async (e) => {
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            markcompleted: e.target.checked,
                                                        }));
                                                    }}
                                                />}
                                            label="Mark As Completed"
                                        />
                                    </FormGroup>
                                )}
                            </Box>
                        ) : (
                            <center>
                                <Box>
                                    <Typography>Project: {projectData?.name}</Typography>
                                    <Typography>Vendor: {selectedData.filter((a) => a.product_data?.vendor?.name)?.[0]?.product_data?.vendor?.name || selectedData.filter((a) => a.product?.vendor?.name)?.[0]?.product?.vendor?.name || '--'}</Typography>
                                    <Typography>Number of Items: {selectedData?.length}</Typography>
                                </Box>
                                <PoItems
                                    groupedItems={groupedItems}
                                    projectData={projectData}
                                    actionName={actionType === 1 ? 'requisition' : actionType === 2 ? 'bidding' : actionType === 3 ? 'rfq' : actionType === 4 ? 'purchase_action' : ''}
                                    isFromCreate
                                />
                                <Box display="flex" flexDirection="column" gap={2} width="50%" mt={2}>
                                    <Autocomplete
                                        value={selectedData.find((c) => c.item_id === selectedItem?.item_id) || null}
                                        id="combo-box-demo"
                                        size="small"
                                        fullWidth
                                        options={selectedData}
                                        getOptionLabel={(a) => `${a?.product?.is_customer_product ?
                                            `C-${a?.product?.alternate_id}`
                                            :
                                            a?.product?.["numaric_sku"] ? `${a?.product?.category?.["sku_no"] || ''}${a?.product?.sub_category?.["sku_no"] || ''}-${String(a?.product?.["numaric_sku"]).padStart(3, '0')}` :
                                                `${a?.product?.category?.["sku_no"] || ''}${a?.product?.sub_category?.["sku_no"] || ''}-${String(0).padStart(3, '0')}`
                                            } - ${a.room?.room_name} - ${a.department?.department_name}${a?.room?.room_no ? ` - ${a?.room?.room_no}` : ''}`}
                                        onChange={async (event, newValue) => {
                                            setSelectedItem(newValue || null);
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                fullWidth
                                                {...params}
                                                label="Select Item"
                                                name="Select Item"
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />}
                                    />
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="Medium"
                                        fullWidth
                                        onClick={async () => {
                                            const response = await apiRequest('get', `/purchase-module?pageNo=1&pageSize=100&projectId=${projectData.project_id}&type=${actionType === 1 ? 'requisition' : actionType === 2 ? 'bidding' : actionType === 3 ? 'rfq' : actionType === 4 ? 'purchase_order' : ''}`)
                                            setActionData(response?.data?.data?.filter((a) => !['rejected', 'cancelled', 'approved'].includes(a.status)));
                                            if (actionType === 1) {
                                                if (selectedData.filter((a) => a.requisition_action_no).length > 0) {
                                                    showNotification('These items are already part of another requisition', 'error');
                                                } else {
                                                    setSubActionType(1)
                                                }
                                            } else if (actionType === 2) {
                                                if (selectedData.filter((a) => a.bidding_action_no).length > 0) {
                                                    showNotification('These items are already part of another bidding', 'error');
                                                } else {
                                                    setSubActionType(1);
                                                }
                                            } else if (actionType === 3) {
                                                if (selectedData.filter((a) => a.rfq).length > 0) {
                                                    showNotification('These items are already part of another rquest for quote', 'error');
                                                } else {
                                                    setSubActionType(1);
                                                }
                                            } else if (actionType === 4) {
                                                if (selectedData.filter((a) => a.purchase_order_action_no).length > 0) {
                                                    showNotification('These items are already part of another purchase order', 'error');
                                                } else {
                                                    setSubActionType(1);
                                                }
                                            }
                                        }}
                                    >
                                        {`ASSIGN TO EXISTING ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bidding' : actionType === 3 ? 'Request for quote' : actionType === 4 ? 'Purchase Order' : ''}`}
                                    </Button>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="Medium"
                                        fullWidth
                                        onClick={() => {
                                            const checkHasType = (type) =>
                                                selectedData.some((a) => a?.[`${type}_action_no`]);

                                            const getByType = (type) =>
                                                selectedData.filter((a) => a?.[`${type}_action_no`]);

                                            const groupByPaId = (data, label) => {
                                                return data.reduce((acc, item) => {
                                                    const id = item?.[`${label}_pa_id`];
                                                    if (!acc[id]) acc[id] = [];
                                                    acc[id].push(item);
                                                    return acc;
                                                }, {});
                                            };

                                            const validateSameGroup = async (data, label) => {
                                                const grouped = groupByPaId(data, label);
                                                if (Object.keys(grouped).length === 1) {
                                                    if (selectedData.filter((a) => a?.[`${label}_action_no`])?.length > 0) {
                                                        const response = await apiRequest('get', `/purchase-module/${selectedData?.find((a) => a?.[`${label}_action_no`])?.[`${label}_purchase_module_id`]}`);
                                                        const { data } = response.data;
                                                        if (data?.items?.length > 0) {
                                                            const updatedItems = data.items.map(item => ({
                                                                ...item,
                                                                stage: selectedData?.find((a) => a?.[`${label}_action_no`])?.stage,
                                                                [`${label}_action_no`]: selectedData?.find((a) => a?.[`${label}_action_no`])?.[`${label}_action_no`],
                                                                [`${label}_purchase_module_id`]: selectedData?.find((a) => a?.[`${label}_purchase_module_id`])?.[`${label}_purchase_module_id`],
                                                                [`${label}_pa_id`]: selectedData?.find((a) => a?.[`${label}_pa_id`])?.[`${label}_pa_id`],
                                                            }));
                                                            setSelectedData(updatedItems);
                                                        }
                                                        setPAData((prevData) => ({
                                                            ...prevData,
                                                            actionid: selectedData?.find((a) => a?.[`${label}_action_no`])?.[`${label}_pa_id`]
                                                        }));
                                                        setSubActionType(2);
                                                    }
                                                } else {
                                                    showNotification(`All selected items must exist in same ${label}`, "error");
                                                }
                                            };

                                            const validateProcess = (type, label) => {
                                                const filtered = getByType(type);
                                                if (filtered.length === 0) {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        actionid: selectedData?.find((a) => a?.[`${label}_action`])?.[`${label}_pa_id`]
                                                    }));
                                                    return setSubActionType(2);
                                                }

                                                if (filtered.length !== selectedData.length) {
                                                    showNotification(`${label} must be completed for all selected items`, "error");
                                                    return;
                                                }

                                                validateSameGroup(filtered, label);
                                            };

                                            // Main logic
                                            if (actionType === 1) {
                                                if (checkHasType("requisition")) {
                                                    showNotification("These items are already part of another requisition", "error");
                                                } else {
                                                    setSubActionType(2);
                                                }
                                            }

                                            else if (actionType === 2) {
                                                if (checkHasType("bidding")) {
                                                    showNotification("These items are already part of another bidding", "error");
                                                } else {
                                                    validateProcess("requisition", "requisition");
                                                }
                                            }

                                            else if (actionType === 3) {
                                                if (checkHasType("rfq")) {
                                                    showNotification("These items are already part of another rquest for quote", "error");
                                                } else if (checkHasType("requisition")) {
                                                    validateProcess("requisition", "requisition");
                                                } else if (checkHasType("bidding")) {
                                                    validateProcess("bidding", "bidding");
                                                } else {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        actionid: selectedData?.find((a) => a.rfq_action_no)?.rfq_pa_id
                                                    }));
                                                    setSubActionType(2);
                                                }
                                            }

                                            else if (actionType === 4) {
                                                if (checkHasType("purchase_order")) {
                                                    showNotification("These items are already part of another purchase order", "error");
                                                } else if (checkHasType("requisition")) {
                                                    validateProcess("requisition", "requisition");
                                                } else if (checkHasType("bidding")) {
                                                    validateProcess("bidding", "bidding");
                                                } else if (checkHasType("rfq")) {
                                                    validateProcess("rfq", "request for quote");
                                                } else {
                                                    setPAData((prevData) => ({
                                                        ...prevData,
                                                        actionid: selectedData?.find((a) => a.purchase_order_action_no)?.purchase_order_pa_id
                                                    }));
                                                    setSubActionType(2);
                                                }
                                            }
                                        }}
                                    >
                                        {`Create New ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bidding' : actionType === 3 ? 'Request for quote' : actionType === 4 ? 'Purchase Order' : ''}`}
                                    </Button>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="Medium"
                                        fullWidth
                                        onClick={async () => {
                                            if (selectedItem?.item_id) {
                                                if (actionType === 1) {
                                                    if (selectedItem?.requisition_action_no) {
                                                        const res = await apiRequest('get', `/purchase-module/count-by-poid?paId=${selectedItem?.requisition_pa_id}&projectId=${projectData?.project_id}`);
                                                        if (res?.data?.data <= 1) {
                                                            const result = await apiRequest('get', `/purchase-module/${selectedItem?.requisition_purchase_module_id}`);
                                                            const paObj = result.data.data;
                                                            setDataLoading(true);
                                                            const formData = new FormData();
                                                            appendIfNotNull(formData, 'item_id', JSON.stringify(paObj.item_id.filter(id => selectedItem.item_id !== id)));
                                                            appendIfNotNull(formData, 'created_by', user?.user_id);
                                                            appendIfNotNull(formData, 'project_id', projectData.project_id);
                                                            appendIfNotNull(formData, 'organization_id', user?.organization?.organization_id);
                                                            const response = await apiRequest('put', `/purchase-module/${paObj?.purchase_module_id}`, formData);
                                                            if (response.data) {
                                                                await apiRequest('post', '/project-item/update-multiple', {
                                                                    item_ids: [selectedItem.item_id],
                                                                    item_data: {
                                                                        stage: 'pending'
                                                                    }
                                                                });
                                                                setSelectedItem(null);
                                                                setGroupedItems(Object.values(
                                                                    selectedData.filter((a) => a.item_id !== selectedItem.item_id)?.reduce((acc, item) => {
                                                                        const productId = item.product_id;

                                                                        if (!acc[productId]) {
                                                                            acc[productId] = {
                                                                                product_id: productId,
                                                                                items: [],
                                                                                totalQty: 0,
                                                                                totalCost: 0
                                                                            };
                                                                        }

                                                                        const subTotal = item.quantity * item.unit_price;
                                                                        const tax = (item.quantity * item.unit_price * Number((!projectData?.is_tax_exempt ? item.tax : 0))) / 100;

                                                                        let additionalTax = 0;
                                                                        const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;

                                                                        if (taxableOption?.length > 0) {
                                                                            if (taxableOption.includes('Freight')) {
                                                                                additionalTax += ((Number(item.freight) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Installation')) {
                                                                                additionalTax += ((Number(item.installation) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Storage')) {
                                                                                additionalTax += ((Number(item.storage) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Fees')) {
                                                                                additionalTax += ((Number(item.fees) * projectData?.tax_rate) / 100);
                                                                            }
                                                                        }

                                                                        const itemTotalCost = subTotal + tax + Number(item.freight) + Number(item.installation) +
                                                                            Number(item.fees) + Number(item.storage) - Number(item.discounts) -
                                                                            Number(item.tradein) + Number(additionalTax);

                                                                        acc[productId].items.push(item);
                                                                        acc[productId].totalQty += item.quantity * item.room.quantity;
                                                                        acc[productId].totalCost += itemTotalCost * item.room.quantity;

                                                                        return acc;
                                                                    }, {})
                                                                ).map((group) => {
                                                                    const firstItem = group.items[0];
                                                                    const product = firstItem.product;
                                                                    const numericId = product.is_customer_product
                                                                        ? `C-${product.alternate_id}`
                                                                        : product.numaric_sku
                                                                            ? `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(product.numaric_sku).padStart(3, '0')}`
                                                                            : `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(0).padStart(3, '0')}`;

                                                                    return {
                                                                        numericId: numericId,
                                                                        description: `${product.category.name} - ${product.sub_category.name}`,
                                                                        model: product.model,
                                                                        manufacturer: product?.manufacturer?.name,
                                                                        totalQty: group.totalQty,
                                                                        totalCost: group.totalCost,
                                                                        product_id: group.product_id,
                                                                        items: group.items
                                                                    };
                                                                })
                                                                );
                                                                setSelectedData(selectedData.filter((a) => a.item_id !== selectedItem.item_id));
                                                                onGridReady({
                                                                    api: gridApi
                                                                });
                                                                showNotification(`Item successfully remove from Requisition`, 'success');
                                                                setDataLoading(false);
                                                            }
                                                        } else {
                                                            showNotification(`This item is already part of another requisition`, 'error');
                                                        }
                                                    } else {
                                                        showNotification('Requisition details is not found for selected item', 'error');
                                                    }
                                                } else if (actionType === 2) {
                                                    if (selectedItem?.bidding_action_no) {
                                                        const res = await apiRequest('get', `/purchase-module/count-by-poid?paId=${selectedItem?.bidding_pa_id}&projectId=${projectData?.project_id}`);
                                                        if (res?.data?.data <= 1) {
                                                            const result = await apiRequest('get', `/purchase-module/${selectedItem?.bidding_purchase_module_id}`);
                                                            const paObj = result.data.data;
                                                            setDataLoading(true);
                                                            const formData = new FormData();
                                                            appendIfNotNull(formData, 'item_id', JSON.stringify(paObj.item_id.filter(id => selectedItem.item_id !== id)));
                                                            appendIfNotNull(formData, 'created_by', user?.user_id);
                                                            appendIfNotNull(formData, 'project_id', projectData.project_id);
                                                            appendIfNotNull(formData, 'organization_id', user?.organization?.organization_id);
                                                            const response = await apiRequest('put', `/purchase-module/${paObj?.purchase_module_id}`, formData);
                                                            if (response.data) {
                                                                await apiRequest('post', '/project-item/update-multiple', {
                                                                    item_ids: [selectedItem.item_id],
                                                                    item_data: {
                                                                        stage: 'pending'
                                                                    }
                                                                });
                                                                setSelectedItem(null);
                                                                setGroupedItems(Object.values(
                                                                    selectedData.filter((a) => a.item_id !== selectedItem.item_id)?.reduce((acc, item) => {
                                                                        const productId = item.product_id;

                                                                        if (!acc[productId]) {
                                                                            acc[productId] = {
                                                                                product_id: productId,
                                                                                items: [],
                                                                                totalQty: 0,
                                                                                totalCost: 0
                                                                            };
                                                                        }

                                                                        const subTotal = item.quantity * item.unit_price;
                                                                        const tax = (item.quantity * item.unit_price * Number((!projectData?.is_tax_exempt ? item.tax : 0))) / 100;

                                                                        let additionalTax = 0;
                                                                        const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;

                                                                        if (taxableOption?.length > 0) {
                                                                            if (taxableOption.includes('Freight')) {
                                                                                additionalTax += ((Number(item.freight) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Installation')) {
                                                                                additionalTax += ((Number(item.installation) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Storage')) {
                                                                                additionalTax += ((Number(item.storage) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Fees')) {
                                                                                additionalTax += ((Number(item.fees) * projectData?.tax_rate) / 100);
                                                                            }
                                                                        }

                                                                        const itemTotalCost = subTotal + tax + Number(item.freight) + Number(item.installation) +
                                                                            Number(item.fees) + Number(item.storage) - Number(item.discounts) -
                                                                            Number(item.tradein) + Number(additionalTax);

                                                                        acc[productId].items.push(item);
                                                                        acc[productId].totalQty += item.quantity * item.room.quantity;
                                                                        acc[productId].totalCost += itemTotalCost * item.room.quantity;

                                                                        return acc;
                                                                    }, {})
                                                                ).map((group) => {
                                                                    const firstItem = group.items[0];
                                                                    const product = firstItem.product;
                                                                    const numericId = product.is_customer_product
                                                                        ? `C-${product.alternate_id}`
                                                                        : product.numaric_sku
                                                                            ? `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(product.numaric_sku).padStart(3, '0')}`
                                                                            : `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(0).padStart(3, '0')}`;

                                                                    return {
                                                                        numericId: numericId,
                                                                        description: `${product.category.name} - ${product.sub_category.name}`,
                                                                        model: product.model,
                                                                        manufacturer: product?.manufacturer?.name,
                                                                        totalQty: group.totalQty,
                                                                        totalCost: group.totalCost,
                                                                        product_id: group.product_id,
                                                                        items: group.items
                                                                    };
                                                                })
                                                                );
                                                                setSelectedData(selectedData.filter((a) => a.item_id !== selectedItem.item_id));
                                                                onGridReady({
                                                                    api: gridApi
                                                                });
                                                                showNotification(`Item successfully remove from Bid`, 'success');
                                                                setDataLoading(false);
                                                            }
                                                        } else {
                                                            showNotification(`This item is already part of another bidding`, 'error');
                                                        }
                                                    } else {
                                                        showNotification('Bidding details is not found for selected item', 'error');
                                                    }
                                                } else if (actionType === 3) {
                                                    if (selectedItem?.rfq_action_no) {
                                                        const res = await apiRequest('get', `/purchase-module/count-by-poid?paId=${selectedItem?.rfq_pa_id}&projectId=${projectData?.project_id}`);
                                                        if (res.data.data <= 1) {
                                                            const result = await apiRequest('get', `/purchase-module/${selectedItem?.rfq_purchase_module_id}`);
                                                            const paObj = result.data.data;
                                                            setDataLoading(true);
                                                            const formData = new FormData();
                                                            appendIfNotNull(formData, 'item_id', JSON.stringify(paObj.item_id.filter(id => selectedItem.item_id !== id)));
                                                            appendIfNotNull(formData, 'created_by', user?.user_id);
                                                            appendIfNotNull(formData, 'project_id', projectData.project_id);
                                                            appendIfNotNull(formData, 'organization_id', user?.organization?.organization_id);
                                                            const response = await apiRequest('put', `/purchase-module/${paObj?.purchase_module_id}`, formData);
                                                            if (response.data) {
                                                                await apiRequest('post', '/project-item/update-multiple', {
                                                                    item_ids: [selectedItem.item_id],
                                                                    item_data: {
                                                                        stage: 'pending'
                                                                    }
                                                                });
                                                                setSelectedItem(null);
                                                                setGroupedItems(Object.values(
                                                                    selectedData.filter((a) => a.item_id !== selectedItem.item_id)?.reduce((acc, item) => {
                                                                        const productId = item.product_id;

                                                                        if (!acc[productId]) {
                                                                            acc[productId] = {
                                                                                product_id: productId,
                                                                                items: [],
                                                                                totalQty: 0,
                                                                                totalCost: 0
                                                                            };
                                                                        }

                                                                        const subTotal = item.quantity * item.unit_price;
                                                                        const tax = (item.quantity * item.unit_price * Number((!projectData?.is_tax_exempt ? item.tax : 0))) / 100;

                                                                        let additionalTax = 0;
                                                                        const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;

                                                                        if (taxableOption?.length > 0) {
                                                                            if (taxableOption.includes('Freight')) {
                                                                                additionalTax += ((Number(item.freight) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Installation')) {
                                                                                additionalTax += ((Number(item.installation) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Storage')) {
                                                                                additionalTax += ((Number(item.storage) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Fees')) {
                                                                                additionalTax += ((Number(item.fees) * projectData?.tax_rate) / 100);
                                                                            }
                                                                        }

                                                                        const itemTotalCost = subTotal + tax + Number(item.freight) + Number(item.installation) +
                                                                            Number(item.fees) + Number(item.storage) - Number(item.discounts) -
                                                                            Number(item.tradein) + Number(additionalTax);

                                                                        acc[productId].items.push(item);
                                                                        acc[productId].totalQty += item.quantity * item.room.quantity;
                                                                        acc[productId].totalCost += itemTotalCost * item.room.quantity;

                                                                        return acc;
                                                                    }, {})
                                                                ).map((group) => {
                                                                    const firstItem = group.items[0];
                                                                    const product = firstItem.product;
                                                                    const numericId = product.is_customer_product
                                                                        ? `C-${product.alternate_id}`
                                                                        : product.numaric_sku
                                                                            ? `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(product.numaric_sku).padStart(3, '0')}`
                                                                            : `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(0).padStart(3, '0')}`;

                                                                    return {
                                                                        numericId: numericId,
                                                                        description: `${product.category.name} - ${product.sub_category.name}`,
                                                                        model: product.model,
                                                                        manufacturer: product?.manufacturer?.name,
                                                                        totalQty: group.totalQty,
                                                                        totalCost: group.totalCost,
                                                                        product_id: group.product_id,
                                                                        items: group.items
                                                                    };
                                                                })
                                                                );
                                                                setSelectedData(selectedData.filter((a) => a.item_id !== selectedItem.item_id));
                                                                onGridReady({
                                                                    api: gridApi
                                                                });
                                                                showNotification(`Item successfully remove from Request for quote`, 'success');
                                                                setDataLoading(false);
                                                            }
                                                        } else {
                                                            showNotification(`This item is already part of another Request for quote`, 'error');
                                                        }
                                                    } else {
                                                        showNotification('RFQ details is not found for selected item', 'error');
                                                    }
                                                } else if (actionType === 4) {
                                                    if (selectedItem?.purchase_order_action_no) {
                                                        const res = await apiRequest('get', `/purchase-module/count-by-poid?paId=${selectedItem?.purchase_order_pa_id}&projectId=${projectData?.project_id}`);
                                                        if (res.data.data <= 1) {
                                                            const result = await apiRequest('get', `/purchase-module/${selectedItem?.purchase_order_purchase_module_id}`);
                                                            const paObj = result.data.data;
                                                            setDataLoading(true);
                                                            const formData = new FormData();
                                                            appendIfNotNull(formData, 'item_id', JSON.stringify(paObj.item_id.filter(id => selectedItem.item_id !== id)));
                                                            appendIfNotNull(formData, 'created_by', user?.user_id);
                                                            appendIfNotNull(formData, 'project_id', projectData.project_id);
                                                            appendIfNotNull(formData, 'organization_id', user?.organization?.organization_id);
                                                            const response = await apiRequest('put', `/purchase-module/${paObj?.purchase_module_id}`, formData);
                                                            if (response.data) {
                                                                await apiRequest('post', '/project-item/update-multiple', {
                                                                    item_ids: [selectedItem.item_id],
                                                                    item_data: {
                                                                        stage: 'pending'
                                                                    }
                                                                });
                                                                setSelectedItem(null);
                                                                setGroupedItems(Object.values(
                                                                    selectedData.filter((a) => a.item_id !== selectedItem.item_id)?.reduce((acc, item) => {
                                                                        const productId = item.product_id;

                                                                        if (!acc[productId]) {
                                                                            acc[productId] = {
                                                                                product_id: productId,
                                                                                items: [],
                                                                                totalQty: 0,
                                                                                totalCost: 0
                                                                            };
                                                                        }

                                                                        const subTotal = item.quantity * item.unit_price;
                                                                        const tax = (item.quantity * item.unit_price * Number((!projectData?.is_tax_exempt ? item.tax : 0))) / 100;

                                                                        let additionalTax = 0;
                                                                        const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;

                                                                        if (taxableOption?.length > 0) {
                                                                            if (taxableOption.includes('Freight')) {
                                                                                additionalTax += ((Number(item.freight) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Installation')) {
                                                                                additionalTax += ((Number(item.installation) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Storage')) {
                                                                                additionalTax += ((Number(item.storage) * projectData?.tax_rate) / 100);
                                                                            }
                                                                            if (taxableOption.includes('Fees')) {
                                                                                additionalTax += ((Number(item.fees) * projectData?.tax_rate) / 100);
                                                                            }
                                                                        }

                                                                        const itemTotalCost = subTotal + tax + Number(item.freight) + Number(item.installation) +
                                                                            Number(item.fees) + Number(item.storage) - Number(item.discounts) -
                                                                            Number(item.tradein) + Number(additionalTax);

                                                                        acc[productId].items.push(item);
                                                                        acc[productId].totalQty += item.quantity * item.room.quantity;
                                                                        acc[productId].totalCost += itemTotalCost * item.room.quantity;

                                                                        return acc;
                                                                    }, {})
                                                                ).map((group) => {
                                                                    const firstItem = group.items[0];
                                                                    const product = firstItem.product;
                                                                    const numericId = product.is_customer_product
                                                                        ? `C-${product.alternate_id}`
                                                                        : product.numaric_sku
                                                                            ? `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(product.numaric_sku).padStart(3, '0')}`
                                                                            : `${product.category?.sku_no || ''}${product.sub_category?.sku_no || ''}-${String(0).padStart(3, '0')}`;

                                                                    return {
                                                                        numericId: numericId,
                                                                        description: `${product.category.name} - ${product.sub_category.name}`,
                                                                        model: product.model,
                                                                        manufacturer: product?.manufacturer?.name,
                                                                        totalQty: group.totalQty,
                                                                        totalCost: group.totalCost,
                                                                        product_id: group.product_id,
                                                                        items: group.items
                                                                    };
                                                                })
                                                                );
                                                                setSelectedData(selectedData.filter((a) => a.item_id !== selectedItem.item_id));
                                                                onGridReady({
                                                                    api: gridApi
                                                                });
                                                                showNotification(`Item successfully remove from Purchase Order`, 'success');
                                                                setDataLoading(false);
                                                            }
                                                        } else {
                                                            showNotification(`This item is already part of another Purchase Order`, 'error');
                                                        }
                                                    } else {
                                                        showNotification('Purchase order details is not found for selected item', 'error');
                                                    }
                                                }
                                            } else {
                                                showNotification('Please select item before proceed to delete', 'error');
                                            }
                                        }}
                                    >
                                        {`Remove From ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bidding' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'Purchase Order' : ''}`}
                                    </Button>
                                </Box>
                            </center>
                        ) : (
                            <center>
                                <Box display="flex" flexDirection="column" gap={2} width="60%">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="Medium"
                                        fullWidth
                                        onClick={() => {
                                            setActionType(1);
                                        }}
                                    >
                                        Requisition
                                    </Button>
                                    {!BasicAccess.includes(user?.organization?.Subscriptions[0]?.plan_id) && (
                                        <>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                size="Medium"
                                                fullWidth
                                                onClick={() => {
                                                    setActionType(2);
                                                }}
                                            >
                                                Bidding
                                            </Button>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                size="Medium"
                                                fullWidth
                                                onClick={() => {
                                                    setActionType(3);
                                                }}
                                            >
                                                Request for Quote (RFQ)
                                            </Button>
                                        </>
                                    )}
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="Medium"
                                        fullWidth
                                        onClick={() => {
                                            setActionType(4);
                                        }}
                                    >
                                        Purchase Order
                                    </Button>
                                </Box>
                            </center>
                        )}
                </DialogContent>
                <Divider />
                <DialogActions>
                    {subActionType !== null && (
                        <Button
                            color="primary"
                            variant="contained"
                            size="Medium"
                            onClick={async () => {
                                try {
                                    if (subActionType === 2) {
                                        const newErrors = {};
                                        if (paData.name === null) {
                                            newErrors.name = `Please Enter ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} Name`;
                                        }
                                        if (paData.actionno === null) {
                                            newErrors.actionno = `Please Enter ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid ' : actionType === 3 ? 'RFQ' : actionType === 4 ? 'PO' : ''} No`;
                                        }

                                        if (paData.procontactid === null && actionType !== 1) {
                                            newErrors.projectcontact = 'Please select project contact'
                                        }

                                        if (paData.vendorid === null && actionType === 4) {
                                            newErrors.vender = 'Please select vendor'
                                        }

                                        if (paData.vendorid !== null && paData.vendoraddressid === null && actionType !== 1) {
                                            newErrors.venderAddress = 'Please select vendor location'
                                        }
                                        if (paData.vendorid !== null && paData.vendorcontactid === null && actionType !== 1) {
                                            newErrors.vendorcontactid = 'Please select vendor contact'
                                        }

                                        setErrors(newErrors);

                                        if (Object.keys(newErrors).length === 0) {
                                            setDataLoading(true);
                                            const formData = new FormData();
                                            appendIfNotNull(formData, 'item_id', JSON.stringify(selectedData.map((a) => a.item_id)));
                                            if (paData.actionid !== null) {
                                                appendIfNotNull(formData, 'action_id', paData.actionid);
                                                appendIfNotNull(formData, 'pa_id', paData.actionid);
                                            }
                                            appendIfNotNull(formData, 'action_name', paData.name);
                                            appendIfNotNull(formData, 'action_no', paData.actionno);
                                            appendIfNotNull(formData, 'notes', paData.actionnotes);
                                            appendIfNotNull(formData, 'project_contact_id', paData?.procontactid);
                                            appendIfNotNull(formData, 'vendor_id', paData.vendorid);
                                            appendIfNotNull(formData, 'vender_address_id', paData.vendoraddressid);
                                            appendIfNotNull(formData, 'vender_contact_id', paData.vendorcontactid);
                                            appendIfNotNull(formData, 'shipping_address_id', paData.shippingaddressid);
                                            appendIfNotNull(formData, 'billing_address_id', paData.billaddressid);
                                            appendIfNotNull(formData, 'shipping_teams_id', paData.shippingterms);
                                            appendIfNotNull(formData, 'payment_teams_id', paData.paymentterms);
                                            appendIfNotNull(formData, 'shipping_contact_id', paData.shippingcontactid);
                                            appendIfNotNull(formData, 'billing_contact_id', paData.billcontactid);
                                            appendIfNotNull(formData, 'shipping_note', paData.shippingnotes);
                                            appendIfNotNull(formData, 'billing_note', paData.billnotes);
                                            appendIfNotNull(formData, 'no_earlier_than_date', paData?.earlydelivery !== 'Invalid date' && paData?.earlydelivery !== null ? moment(paData?.earlydelivery).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                            appendIfNotNull(formData, 'no_later_than_date', paData?.laterdelivery !== 'Invalid date' && paData?.laterdelivery !== null ? moment(paData?.laterdelivery).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                            appendIfNotNull(formData, 'issued_date', paData?.issueddate !== 'Invalid date' && paData?.issueddate !== null ? moment(paData?.issueddate).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                            appendIfNotNull(formData, 'created_date', paData?.createddate !== 'Invalid date' && paData?.createddate !== null ? moment(paData?.createddate).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                            appendIfNotNull(formData, 'quote', paData?.quote ? paData?.quote : null);
                                            appendIfNotNull(formData, 'quote_date', paData?.quote_received_date !== 'Invalid date' && paData?.quote_received_date !== null ? moment(paData?.quote_received_date).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                            appendIfNotNull(formData, 'quote_expiration_date', paData?.quote_expiration_date !== 'Invalid date' && paData?.quote_expiration_date !== null ? moment(paData?.quote_expiration_date).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                            appendIfNotNull(formData, 'status', paData.markcompleted ? 'completed' : 'In-progress');
                                            appendIfNotNull(formData, 'bid_group_id', paData?.bid_group_id);
                                            appendIfNotNull(formData, 'type', actionType === 1 ? 'requisition' : actionType === 2 ? 'bidding' : actionType === 3 ? 'rfq' : 'purchase_order')
                                            if (resources?.document1 && resources?.document1 !== null) {
                                                formData.append('document_1_file', resources?.document1);
                                            } else if (rows.find((a) => a.type === 'Document 1')?.resource === '--') {
                                                formData.append('document_1', null);
                                            }
                                            if (resources?.document2 && resources?.document2 !== null) {
                                                formData.append('document_2_file', resources?.document2);
                                            } else if (rows.find((a) => a.type === 'Document 2')?.resource === '--') {
                                                formData.append('document_2', null);
                                            }
                                            if (resources?.document3 && resources?.document3 !== null) {
                                                formData.append('document_3_file', resources?.document3);
                                            } else if (rows.find((a) => a.type === 'Document 3')?.resource === '--') {
                                                formData.append('document_3', null);
                                            }
                                            if (resources?.document4 && resources?.document4 !== null) {
                                                formData.append('document_4_file', resources?.document4);
                                            } else if (rows.find((a) => a.type === 'Document 4')?.resource === '--') {
                                                formData.append('document_4', null);
                                            }
                                            const doc5 = resources?.[`approved${actionType === 1 ? 'requisition' : actionType === 2 ? 'bid' : actionType === 3 ? 'requestforquote' : 'purchaseorder'}`];
                                            if (doc5 && doc5 !== null) {
                                                formData.append('document_5_file', doc5);
                                            } else if (rows.find((a) => a.type === `Approved ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid' : actionType === 3 ? 'Request For Quote' : 'Purchase Order'}`)?.resource === '--') {
                                                formData.append('document_5', null);
                                            }
                                            appendIfNotNull(formData, 'created_by', user?.user_id);
                                            appendIfNotNull(formData, 'project_id', projectData.project_id);
                                            appendIfNotNull(formData, 'organization_id', user?.organization?.organization_id);
                                            const response = await apiRequest('post', '/purchase-module', formData);
                                            if (response?.data?.data) {
                                                const itemData = {
                                                    vendor_id: paData.vendorid,
                                                    bid_group_id: paData.bid_group_id,
                                                    ...(paData.markcompleted && {
                                                        stage:
                                                            actionType === 1
                                                                ? 'requisitioned'
                                                                : actionType === 2
                                                                    ? 'bidding'
                                                                    : actionType === 3
                                                                        ? 'quote_requested'
                                                                        : actionType === 4
                                                                            ? 'purchased'
                                                                            : 'released'
                                                    })
                                                };

                                                await apiRequest('post', '/project-item/update-multiple', {
                                                    item_ids: selectedData.map(a => a.item_id),
                                                    item_data: itemData
                                                });

                                                setPurchaseOpen(false);
                                                setActionType(null);
                                                setSubActionType(null);
                                                setErrors({});
                                                setContactType(null);
                                                setSelectedData([]);
                                                showNotification('Requisition created successfully', 'success');
                                                onGridReady({
                                                    api: gridApi,
                                                    searchingText: ''
                                                });
                                                setPAData({
                                                    name: null,
                                                    actionno: null,
                                                    actionid: null,
                                                    procontactid: null,
                                                    vendorid: null,
                                                    vendoraddressid: null,
                                                    vendorcontactid: null,
                                                    actionnotes: null,
                                                    notestosupplier: null, //pending
                                                    billaddressid: null,
                                                    billcontactid: null,
                                                    billnotes: null,
                                                    paymentterms: null,
                                                    shippingaddressid: null,
                                                    shippingcontactid: null,
                                                    shippingnotes: null,
                                                    shippingterms: null,
                                                    earlydelivery: null,
                                                    laterdelivery: null,
                                                    createddate: null,
                                                    issueddate: null,
                                                    quote: null,
                                                    quote_received_date: null,
                                                    quote_expiration_date: null,
                                                    markcompleted: false,
                                                    bid_group_id: null
                                                });
                                                setDataLoading(false);
                                            }
                                        }
                                    } else {
                                        if (actionId !== null) {
                                            const formData = new FormData();
                                            const itemIds = [...actionData.find((a) => a.purchase_module_id === actionId)?.item_id, ...selectedData.map((a) => a.item_id)];
                                            const res = await apiRequest('get', `/purchase-module/count-by-poid?paId=${actionData.find((a) => a.purchase_module_id === actionId)?.pa_id}&projectId=${projectData?.project_id}`);
                                            if (res?.data?.data <= 1) {
                                                setDataLoading(true);
                                                appendIfNotNull(formData, 'item_id', JSON.stringify(itemIds));
                                                appendIfNotNull(formData, 'created_by', user?.user_id);
                                                appendIfNotNull(formData, 'project_id', projectData.project_id);
                                                appendIfNotNull(formData, 'organization_id', user?.organization?.organization_id);
                                                const response = await apiRequest('put', `/purchase-module/${actionId}`, formData);
                                                if (response.data) {
                                                    await apiRequest('post', '/project-item/update-multiple', {
                                                        item_ids: selectedData.map((a) => a.item_id),
                                                        item_data: {
                                                            stage: actionData.find((a) => a.purchase_module_id === actionId)?.status === 'completed' ? actionType === 1 ? 'requisitioned' : actionType === 2 ? 'bidding' : actionType === 3 ? 'quote_requested' : actionType === 4 ? 'purchased' : 'released' : 'released'
                                                        }
                                                    });
                                                    setPurchaseOpen(false);
                                                    setActionType(null);
                                                    setSubActionType(null);
                                                    setActionData([]);
                                                    setActionId(null);
                                                    setSelectedData([]);
                                                    showNotification(`Item successfully assign to existing ${actionType === 1 ? 'Requisition' :
                                                        actionType === 2 ? 'Bidding' :
                                                            actionType === 3 ? 'Request for Quote' :
                                                                actionType === 4 ? 'Purchase Order' :
                                                                    'Purchase'}`, 'success');
                                                    onGridReady({
                                                        api: gridApi,
                                                        searchingText: ''
                                                    });
                                                    setDataLoading(false);
                                                }
                                            } else {
                                                showNotification(`Due to more than 1 action associated with selected ${actionType === 1 ? 'Requisition' : actionType === 2 ? 'Bid' : actionType === 3 ? 'Request for quote' : 'Purchase Order'} you can't assign item.`, 'error');
                                            }
                                        } else {
                                            showNotification('Please select purchase action', 'error');
                                        }
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error')
                                }
                            }}
                        >
                            Save
                        </Button>
                    )}
                    <Button
                        color="secondary"
                        variant="contained"
                        size="Medium"
                        onClick={() => {
                            setPurchaseOpen(false);
                            setActionType(null);
                            setSubActionType(null);
                            setErrors({});
                            setContactType(null);
                            setActionData([]);
                            setActionId(null);
                            setSelectedItem(null);
                            setPAData({
                                name: null,
                                actionno: null,
                                actionid: null,
                                procontactid: null,
                                vendorid: null,
                                vendoraddressid: null,
                                vendorcontactid: null,
                                actionnotes: null,
                                notestosupplier: null,
                                billaddressid: null,
                                billcontactid: null,
                                billnotes: null,
                                paymentterms: null,
                                shippingaddressid: null,
                                shippingcontactid: null,
                                shippingnotes: null,
                                shippingterms: null,
                                earlydelivery: null,
                                laterdelivery: null,
                                createddate: null,
                                issueddate: null,
                                quote: null,
                                quote_received_date: null,
                                quote_expiration_date: null,
                                markcompleted: false,
                                bid_group_id: null
                            });
                        }}
                    >
                        CANCEL
                    </Button>
                </DialogActions>
            </Dialog>
            <Drawer
                anchor="bottom"
                open={itemOpen}
                sx={{
                    '& .MuiDrawer-paper': {
                        height: '60%',
                    }
                }}
            >
                <UpdateItem
                    setItemOpen={setItemOpen}
                    selectedData={selectedData}
                    projectData={projectData}
                    onGridReady={() => {
                        onGridReady({
                            api: gridApi
                        })
                    }}
                />
            </Drawer>
            {
                cataLogOpen && (
                    <CreateItemFromCatalog
                        cataLogOpen={cataLogOpen}
                        setCatalogOpen={setCatalogOpen}
                        projectData={projectData}
                        room={room}
                        onGridReady={() => {
                            onGridReady({
                                api: gridApi
                            })
                        }}
                    />
                )
            }
            {
                templateOpen && (
                    <CreateItemFromTemplate
                        templateOpen={templateOpen}
                        setTemplateOpen={setTemplateOpen}
                        projectData={projectData}
                        room={room}
                        level={level}
                        department={department}
                        innerLabel={innerLabel}
                        onGridReady={() => {
                            onGridReady({
                                api: gridApi
                            })
                        }}
                    />
                )
            }
            {
                (departmentOpen && innerLabel === 'Department') && (
                    <CopyMoveDepartment
                        departmentOpen={departmentOpen}
                        setDepartmentOpen={setDepartmentOpen}
                        isMove={isMove}
                        setIsMove={setIsMove}
                        selectedData={selectedData}
                        setSelectedData={setSelectedData}
                        projectData={projectData}
                        onGridReady={() => {
                            onGridReady({
                                api: gridApi
                            })
                        }}
                    />
                )
            }
            {
                (departmentOpen && innerLabel === 'Room') && (
                    <CopyMoveRoom
                        departmentOpen={departmentOpen}
                        setDepartmentOpen={setDepartmentOpen}
                        isMove={isMove}
                        setIsMove={setIsMove}
                        selectedData={selectedData}
                        setSelectedData={setSelectedData}
                        projectData={projectData}
                        onGridReady={() => {
                            onGridReady({
                                api: gridApi
                            })
                        }}
                    />
                )
            }
            {
                (departmentOpen && innerLabel === 'Item') && (
                    <CopyMoveItem
                        departmentOpen={departmentOpen}
                        setDepartmentOpen={setDepartmentOpen}
                        isMove={isMove}
                        setIsMove={setIsMove}
                        selectedData={selectedData}
                        setSelectedData={setSelectedData}
                        projectData={projectData}
                        onGridReady={() => {
                            onGridReady({
                                api: gridApi
                            })
                        }}
                    />
                )
            }
        </Box >
    )
}

export default CommonModule;